<template>
  <div>
    <!-- ============================================================== -->
    <!-- Page wrapper  -->
    <!-- ============================================================== -->
    <div class="page-wrapper">
         <DropDownModal
        v-if="showDropDownModal"
        :p_visitId="p_visitId"
        :button_Name="button_Name"
        :AppModelId='18'
        @close-modal="dropdownModalClosed(false)"
      ></DropDownModal>
      <!-- ============================================================== -->
      <!-- Container fluid  -->
      <!-- ============================================================== -->
      <div class="container-fluid">
        <!-- ============================================================== -->
        <!-- Bread crumb and right sidebar toggle -->
        <!-- ============================================================== -->
        <div class="row page-titles">
          <div class="col-md-5 align-self-center">
            <h4 class="text-themecolor">Check Out</h4>
          </div>
          <div class="col-md-7 align-self-center text-right">
            <div class="d-flex justify-content-end align-items-center">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="dashboard">Home</a>
                </li>
                <li class="breadcrumb-item active">Check Out</li>
              </ol>
            </div>
          </div>
        </div>

        <PatientsSearchComponent
          @apply-search-click="applySearchClick()"
          :called_by="'CheckOutModal'"
        ></PatientsSearchComponent>
        <div class="card p-3">
          <div class="table-responsive">
            <div
              class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer"
            >
              <div class="dataTables_length">
                <span style="margin-right: 10px"
                  ><label for="">Show </label>
                </span>
                <select
                  v-model="pageSize"
                  class="form-control form-control-sm"
                  aria-label="Default select example"
                  @change="pageChange(1)"
                >
                  <option selected>50</option>
                  <option value="100">100</option>
                  <option value="500">500</option>
                  <option value="1000">1000</option>
                  <option value="2000">2000</option>
                </select>

                <span style="margin-left: 10px">
                  <label for=""> Entries </label></span
                >
              </div>
              <!-- <div class="dataTables_filter">
                  <span class="float-right">
                    <span style="margin-right: 10px"><label for="Search">Search:</label></span>
                    <input type="text" @change="SearchDataTable()" v-model="filter" name="" id="" />
                  </span>
                </div> -->
            </div>
               <table
              class="
                table
                display
                table-bordered
                text-center
                table-striped
                no-wrap
              "
              id="home_2"
            >
              <thead class="thead-dark">
                  <tr>
                   <th style="text-align: start">
                     View Visits<span>
                      <!-- <button class="asc-desc-btn" @click="orderBy(1)">
                        &uarr; &darr;
                      </button> -->
                    </span>
                  </th>
                   <th style="text-align: start">
                   Name & DOB<span>
                      <button class="asc-desc-btn" @click="orderBy(1)">
                        &uarr; &darr;
                      </button>
                    </span>
                  </th>
                    <th style="text-align: start">
                   Visit Type<span>
                      <button class="asc-desc-btn" @click="orderBy(2)">
                        &uarr; &darr;
                      </button>
                    </span>
                  </th>
                   <th style="text-align: start">
                   DOS<span>
                      <button class="asc-desc-btn" @click="orderBy(4)">
                        &uarr; &darr;
                      </button>
                    </span>
                  </th>
                  <th style="text-align: start">
                   Time out<span>
                      <button class="asc-desc-btn" @click="orderBy(5)">
                        &uarr; &darr;
                      </button>
                    </span>
                  </th>
                    <th>Next Stage</th>
                  </tr>
                </thead>

                <tbody class="text-center">
                 <tr v-if="allFilterPatientsCheck.length == 0">
                      <td align="center" colspan="100">
                        <strong> No data available</strong>
                      </td>
                 </tr>
                  <tr
                    v-for="(pat, ndx01) in allFilterPatientsCheck"
                    :key="ndx01"
                  >
                      <td>
                      <div class="btn-group">
                        <button
                          type="button"
                          class="btn btn-success"
                          @click="dropDownButtonClick(pat)"
                        >
                          View Visits
                        </button>
                        <button
                          v-if="updButton == 1"
                          type="button"
                          class="
                            btn btn-success
                            dropdown-toggle dropdown-toggle-split
                          "
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          <span class="sr-only">Toggle Dropdown</span>
                        </button>
                          <button
                          v-else 
                          type="button"
                          class="
                            btn btn-success
                            dropdown-toggle dropdown-toggle-split
                          "
                          :disabled="updButton == 0"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          <span class="sr-only">Toggle Dropdown</span>
                        </button>
                        <div class="dropdown-menu animated flipInY">
                          <a
                            class="dropdown-item"
                            href="javascript:void(0)"
                            @click="mergeModalClick(pat)"
                            ><i
                              v-if="pat.patientId <= 0"
                              class="fas fa-exclamation text-danger"
                            ></i
                            >&nbsp; Merge Patients</a
                          >
                              <a
                              class="dropdown-item"
                              href="javascript:void(0)"
                              @click="dropDownButtonClick(pat)"
                              ><i
                                v-if="pat.patientId <= 0"
                                class="fas fa-exclamation text-danger"
                              ></i
                              >&nbsp; Manage Visit</a
                            >
                          <!-- <a
                            class="dropdown-item"
                            href="javascript:void(0)"
                            @click="questionModalClick(pat)"
                            >Questionnaire</a
                          >
                          <a
                            class="dropdown-item"
                            href="javascript:void(0)"
                            @click="commentLeftClick"
                            >Comment Left</a
                          >
                          <a
                            class="dropdown-item"
                            href="javascript:void(0)"
                            @click="editVisitTypeClick(pat)"
                            >Edit Visit Type</a
                          >
                          <a
                            class="dropdown-item"
                            href="javascript:void(0)"
                            @click="collectPaymentClick(pat)"
                            >Collect Payment</a
                          >
                          <a
                            class="dropdown-item"
                            href="javascript:void(0)"
                            @click="sendText1Click(pat)"
                            >Send Text</a
                          >
                          <a
                            class="dropdown-item"
                            href="javascript:void(0)"
                            data-toggle="modal"
                            data-target="#sendEmail1"
                            @click="sendEmailClick(pat)"
                            >Send Email</a
                          >
                          <a
                            v-if="pat.physicianId <= 0"
                            class="dropdown-item"
                            href="javascript:void(0)"
                            @click="assignPhysicianClick(pat)"
                            ><i class="fas fa-exclamation text-danger"></i
                            >&nbsp; Assign Physician</a
                          >
                          <a
                            v-else
                            class="dropdown-item"
                            href="javascript:void(0)"
                            @click="assignPhysicianClick(pat)"
                            >Assign Physician</a
                          >
                          <a
                            class="dropdown-item"
                            href="javascript:void(0)"
                            @click="requestPaymentClick(pat, 1)"
                            >Request Payment</a
                          > -->
                          <a
                            class="dropdown-item"
                            href="javascript:void(0)"
                            data-toggle="modal"
                            id="delete_request"
                            @click="requestDeleteClick(pat)"
                            >Delete</a
                          >
                        </div>
                      </div>
                    </td>
                      <td class="text-left">
                        <div class="btn-group">
                          <a class="mr-2" @click="showProfilPopUpBro(pat)"
                            ><i class="fas fa-user-circle ml-2 text-success"></i
                          ></a>
                          <strong>
                                  <span style="font-size: 14px;display:block;margin-bottom:-25.5px">
                                                                <span class="font-weight-bold">{{ pat.Year }}</span> Y - 
                                                                <span class="font-weight-bold">{{pat.Month}}</span>  M - 
                                                                <span class="font-weight-bold">{{ pat.Days }}</span> D
                                                            </span>
                              <br />
                             <span style="font-size:20px; font-weight:bold">{{ pat.lastName }}</span>, {{ pat.firstName }}
                             <br />
                             <span style="font-size: 13px;display:block;margin-top:-3.5px">{{ pat.dob }}</span>  
                              <br />
                           <span style="display:block;font-size: 13px;margin-top:-23px"><span class="font-weight-bold">{{ pat.ptid }}</span> 
                           <span v-if="pat.externalId === ''"></span>
                           <span v-else>- {{pat.externalId}} </span></span>
                          </strong>
                        </div>
                      </td>

                    <td class="text-left" style="font-weight: 900">
                      {{ pat.vid}}<br />
                      {{ pat.visitType }}<br />
                      {{ pat.visitReason }}<br />
                      {{ pat.physician }}
                    </td>
                    <td class="" style="font-weight: 900">
                      {{ pat.dosStrDate }}
                       <br />
                             <a
                          v-if="pat.physicianId < 0"
                          href="javascript:void(0)"
                          @click="assignPhysicianClick(pat)"
                          class="mytooltip"
                        >
                          <img
                            src="assets/images/actions/stethoscope.png"
                            alt="Provider Assignment Needed"
                            title=""
                            style="height: 20px; margin: 2px"
                          />
                          <span class="tooltip-content5">
                            <span class="tooltip-text3">
                              <span class="tooltip-inner2">
                                <span style="font-weight: 700"
                                  >Provider Assignment Needed</span
                                >
                              </span>
                            </span>
                          </span>
                        </a>
                        <span>
                          <a
                            href="javascript:void(0)"
                            class="mytooltip"
                            @click="requestDeleteClick(pat)"
                          >
                            <i
                              class="fa fa-trash"
                              aria-hidden="true"
                              style="
                                font-size: 15px;
                                margin-left: 6px;
                                margin-top: 0px;
                                color: rgb(255, 102, 102);
                              "
                            ></i>
                            <span class="tooltip-content5">
                              <span class="tooltip-text3">
                                <span class="tooltip-inner2">
                                  <div class="timeline-panel">
                                    <div class="timeline-heading">
                                      <p
                                        class="timeline-title"
                                        style="
                                          font-size: 20px;
                                          font-weight: 800;
                                        "
                                      >
                                        Delete
                                      </p>
                                    </div>
                                    <!-- <div class="timeline-body">
                                      <p>Collected Payment</p>
                                    </div> -->
                                  </div>
                                </span>
                              </span>
                            </span>
                          </a>
                        </span>
                        <br />

                         <span v-if="pat.actionString.indexOf('<500>') > -1">
                            <a
                              href="javascript:void(0)"
                              class="mytooltip"
                              @click="showProfilePopup(pat, 'text')"
                            >
                              <img
                                src="assets/images/actions/sms.png"
                                alt="SMS Sent"
                                style="height: 20px; margin: 2px"
                              />
                              <span class="tooltip-content5">
                                <span class="tooltip-text3">
                                  <span class="tooltip-inner2">
                                    <div class="timeline-panel">
                                      <div class="timeline-heading">
                                        <p
                                          class="timeline-title"
                                          style="
                                            font-size: 20px;
                                            font-weight: 800;
                                            margin-bottom: 0px;
                                          "
                                        >
                                          Text Sent
                                        </p>
                                        <h4
                                          class="timeline-title"
                                          style="margin-bottom: 0px"
                                        >
                                          {{
                                            pat.firstName + " " + pat.lastName
                                          }}
                                        </h4>
                                      </div>
                                      <p style="margin-bottom: 0px">
                                        <small class="text-muted">
                                          <i class="fa fa-clock-o"></i>
                                          {{ pat.smsActionDateStr }}
                                          {{ pat.smsActionTimeStr }}
                                        </small>
                                      </p>
                                      <!-- <div class="timeline-body"
                                       >
                                        <p style="margin-bottom:0px;">Sent to: {{ pat.smsSentTo }}</p>
                                        <p>Message: {{ pat.smsActionText }}</p>
                                      </div> -->
                                    </div>
                                  </span>
                                </span>
                              </span>
                            </a>
                          </span>
                          <!-- email -->
                          <span v-if="pat.actionString.indexOf('<51>') > -1">
                            <a
                              href="javascript:void(0)"
                              class="mytooltip"
                              @click="showProfilePopup(pat, 'email')"
                            >
                              <img
                                src="assets/images/actions/sent.png"
                                alt="Email Sent"
                                style="height: 20px; margin: 2px"
                              />
                              <span class="tooltip-content5">
                                <span class="tooltip-text3">
                                  <span class="tooltip-inner2">
                                    <div class="timeline-panel">
                                      <div class="timeline-heading">
                                        <p
                                          class="timeline-title"
                                          style="
                                            font-size: 20px;
                                            font-weight: 800;
                                            margin-bottom: 0px;
                                          "
                                        >
                                          Email Sent
                                        </p>
                                        <h4
                                          class="timeline-title"
                                          style="margin-bottom: 0px"
                                        >
                                          {{
                                            pat.firstName + " " + pat.lastName
                                          }}
                                        </h4>
                                      </div>
                                      <p>
                                        <small class="text-muted">
                                          <i class="fa fa-clock-o"></i
                                          >{{ pat.emailActionDateStr }}
                                          {{ pat.emailActionTimeStr }}
                                        </small>
                                      </p>
                                      <!-- <div class="timeline-body">
                                        <p>Sent to: {{ pat.emailSentTo }}</p>
                                        <p>subject: {{ pat.emailSubject }}</p>
                                        <p>
                                          Message: {{ pat.emailActionText }}
                                        </p>
                                      </div> -->
                                    </div>
                                  </span>
                                </span>
                              </span>
                            </a>
                          </span>
                          <!-- Comment -->
                          <span v-if="pat.actionString.indexOf('<100>') > -1">
                            <a
                              href="javascript:void(0)"
                              class="mytooltip"
                              @click="dropDownButtonClick(pat, 'comment')"
                            >
                              <img
                                src="assets/images/actions/comment.png"
                                alt="Email Sent"
                                style="height: 20px; margin: 2px"
                              />
                              <span class="tooltip-content5">
                                <span class="tooltip-text3">
                                  <span class="tooltip-inner2">
                                    <div class="timeline-panel">
                                      <div class="timeline-heading">
                                        <p
                                          class="timeline-title"
                                          style="
                                            font-size: 20px;
                                            font-weight: 800;
                                            margin-bottom: 0px;
                                          "
                                        >
                                          Comment Left
                                        </p>
                                        <h4
                                          class="timeline-title"
                                          style="margin-bottom: 0px"
                                        >
                                          {{
                                            pat.firstName + " " + pat.lastName
                                          }}
                                        </h4>
                                      </div>
                                      <p style="margin-bottom: 0px">
                                        <small class="text-muted">
                                          <i class="fa fa-clock-o"></i
                                          >{{ pat.commentActionDateStr }}
                                          {{ pat.commentActionTimeStr }}
                                        </small>
                                      </p>
                                      <div class="timeline-body">
                                        <p>Comment Left</p>
                                      </div>
                                    </div>
                                  </span>
                                </span>
                              </span>
                            </a>
                          </span>
                          <!-- Visit Type -->
                          <span v-if="pat.actionString.indexOf('<50>') > -1">
                            <a
                              href="javascript:void(0)"
                              class="mytooltip"
                              @click="dropDownButtonClick(pat, 'visittype')"
                            >
                              <img
                                src="assets/images/actions/edit.png"
                                alt="Email Sent"
                                style="height: 20px; margin: 2px"
                              />
                              <span class="tooltip-content5">
                                <span class="tooltip-text3">
                                  <span class="tooltip-inner2">
                                    <div class="timeline-panel">
                                      <div class="timeline-heading">
                                        <p
                                          class="timeline-title"
                                          style="
                                            font-size: 20px;
                                            font-weight: 800;
                                            margin-bottom: 0px;
                                          "
                                        >
                                          EDit Visit Type
                                        </p>
                                        <h4
                                          class="timeline-title"
                                          style="margin-bottom: 0px"
                                        >
                                          {{
                                            pat.firstName + " " + pat.lastName
                                          }}
                                        </h4>
                                      </div>
                                      <p>
                                        <small class="text-muted">
                                          <i class="fa fa-clock-o"></i
                                          >{{ pat.editActionDateStr }}
                                          {{ pat.editActionTimeStr }}
                                        </small>
                                      </p>
                                      <div class="timeline-body"></div>
                                    </div>
                                  </span>
                                </span>
                              </span>
                            </a>
                          </span>
                          <!-- paymentRequest -->
                          <span v-if="pat.actionString.indexOf('<301>') > -1">
                            <a
                              href="javascript:void(0)"
                              class="mytooltip"
                              @click="
                                dropDownButtonClick(pat, 'collectpayment')
                              "
                            >
                              <img
                                src="assets/images/actions/credit-card.png"
                                alt="Payment Request Sent"
                                style="height: 20px; margin: 2px"
                              />
                              <span class="tooltip-content5">
                                <span class="tooltip-text3">
                                  <span class="tooltip-inner2">
                                    <div class="timeline-panel">
                                      <div class="timeline-heading">
                                        <p
                                          class="timeline-title"
                                          style="
                                            font-size: 20px;
                                            font-weight: 800;
                                            margin-bottom: 0px;
                                          "
                                        >
                                          Payment Request
                                        </p>
                                        <h4
                                          class="timeline-title"
                                          style="margin-bottom: 0px"
                                        >
                                          {{
                                            pat.firstName + " " + pat.lastName
                                          }}
                                        </h4>
                                      </div>
                                      <p>
                                        <small class="text-muted">
                                          <i class="fa fa-clock-o"></i
                                          >{{ pat.paymentRequestActionDateStr }}
                                          {{ pat.paymentRequestActionTimeStr }}
                                        </small>
                                      </p>
                                      <div class="timeline-body">
                                        <p></p>
                                      </div>
                                    </div>
                                  </span>
                                </span>
                              </span>
                            </a>
                          </span>
                          <!-- paymentCollected -->
                          <span v-if="pat.actionString.indexOf('<300>') > -1">
                            <a
                              href="javascript:void(0)"
                              class="mytooltip"
                              @click="showProfilePopup(pat, 'payment')"
                            >
                              <img
                                src="assets/images/actions/cash-money.png"
                                alt="Payment Collected"
                                style="height: 20px; margin: 2px"
                              />
                              <span class="tooltip-content5">
                                <span class="tooltip-text3">
                                  <span class="tooltip-inner2">
                                    <div class="timeline-panel">
                                      <div class="timeline-heading">
                                        <p
                                          class="timeline-title"
                                          style="
                                            font-size: 20px;
                                            font-weight: 800;
                                            margin-bottom: 0px;
                                          "
                                        >
                                          Payment Collected
                                        </p>
                                        <h4
                                          class="timeline-title"
                                          style="margin-bottom: 0px"
                                        >
                                          {{ pat.collection.collectedByName }}
                                        </h4>
                                      </div>
                                      <p>
                                        <small class="text-muted">
                                          <i class="fa fa-clock-o"></i>
                                          {{ pat.collection.paymentDateStr }}
                                        </small>
                                      </p>
                                      <div class="timeline-body">
                                        <p>Collected Payment</p>
                                      </div>
                                    </div>
                                  </span>
                                </span>
                              </span>
                            </a>
                          </span>
                          <br />
                    </td>
                    <td>
                      <!-- inCorrect time in fix later-->
                      {{ pat.checkedoutLocalDate }}
                      <br />

                      {{ pat.checkedoutLocalTime }}
                    </td>
                    <td>
                      <div class="btn-group">
                        <button
                          v-if="updButton == 1"
                          type="button"
                          class="btn btn-primary dropdown-toggle"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                          :id="'v-' + pat.visitId"
                        >
                          Jump To
                        </button>
                        <button
                          v-else
                          type="button"
                          class="btn btn-primary dropdown-toggle"
                          data-toggle="dropdown"
                          :disabled="updButton == 0"
                          aria-haspopup="true"
                          aria-expanded="false"
                          :id="'v-' + pat.visitId"
                        >
                          Jump To
                        </button>
                        <div class="dropdown-menu animated flipInY">
                          <a
                            v-for="(stage, ndx01) in stagesSteps"
                            :key="ndx01"
                            class="dropdown-item"
                            type="button"
                            data-toggle="modal"
                            id="stage-jump0"
                            ><span @click="ClickOnStage(stage, pat)"
                              >{{ stage.name }}
                            </span>
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
             <nav aria-label="Page navigation">
            <span
              style="padding-left: 40px"
              v-if="totalRows < pageSize * pageNumber"
              >showing {{ totalRows }} of {{ totalRows }} records</span
            >
            <span style="padding-left: 40px" v-else
              >showing {{ pageSize * pageNumber }} of
              {{ totalRows }} records</span
            >
            <ul class="pagination" style="float: right">
              <li class="page-item colorActive">
                <span v-if="pageNumber == 1">
                  <button
                    disabled
                    class="page-link disabledColor"
                    @click="pageChange('Previous')"
                  >
                    Previous
                  </button>
                </span>
                <span v-else>
                  <button class="page-link" @click="pageChange('Previous')">
                    Previous
                  </button>
                </span>
              </li>
               <!--show pagination--> 
                <li v-if="showPagesMin > 1">
                 <button class="page-link" @click="pageChange(1)">
                    1
                  </button>
                </li>
                 <li v-if=" showPagesMin>1 ">
                 <button
                    disabled
                    class="page-link disabledColor"
                  >
                    ...
                    </button>
                 </li>
            <!--show pagination--> 
              <li
                v-for="pageNum in totalPages"
                :key="pageNum"
                class="page-item colorActive"
              >
               <span v-if="pageNum >= showPagesMin && pageNum <= showPagesMax"> 
                <span v-if="pageNumber == pageNum"
                  ><button
                    class="page-link activeColor"
                    disabled
                    @click="pageChange(pageNum)"
                  >
                    {{ pageNum }}
                  </button>
                </span>
                <span v-else>
                  <button class="page-link" @click="pageChange(pageNum)">
                    {{ pageNum }}
                  </button></span
                >
                </span>
              </li>
            <!--show pagination-->          
              <li v-if="totalPagesSuggest > 10 && (totalPagesSuggest-4) >= pageNumber">
                 <button
                    disabled
                    class="page-link disabledColor"
                  >
                    ...
                  </button>
              </li>
             <li v-if="totalPages > 10 &&  (totalPages-4) >= pageNumber">
                 <button class="page-link" @click="pageChange(totalPages)">
                    {{ totalPages }}
                  </button>
             </li>
               <!--show pagination-->  
              <li class="page-item colorActive">
                <span v-if="pageNumber == totalPages">
                  <button
                    disabled
                    class="page-link disabledColor"
                    @click="pageChange('Next')"
                  >
                    Next
                  </button>
                </span>
                <span v-else>
                  <button class="page-link" @click="pageChange('Next')">
                    Next
                  </button>
                </span>
              </li>
            </ul>
          </nav>
          </div>
        </div>
        <!-- ============================================================== -->
      </div>
      <!-- ============================================================== -->
      <!-- End Container fluid  -->
      <!-- ============================================================== -->
    </div>
    <!-- ============================================================== -->
    <!-- End Page wrapper  -->
    <!-- ============================================================== -->

    <!-- **Question Modal -->
    <div
      class="modal fade"
      id="questionModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog cascading-modal modal-lg">
        <div class="modal-content" style="width: 130% !important">
          <div class="modal-header">
            <h4 class="modal-title" id="myLargeModalLabel">
              Visit Questionnaire
            </h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>
          </div>
          <!-- Header -->

          <!-- Body -->
          <div class="modal-body">
            <div class="m-b-10">
              <button
                class="btn btn-outline-success waves-effect col-12"
                @click="questSaveClick"
              >
                Save
              </button>
            </div>

            <form>
              <div
                class="row"
                v-for="(quest, ndx07) in visitQuests"
                :key="ndx07"
              >
                <!--  TEXT  -->
                <div class="col-6" v-if="quest.questionInputTypeId === 1">
                  <fieldset class="floating-labels">
                    <div
                      class="form-group m-b-40"
                      :class="[quest.answer != null ? 'focused' : '']"
                    >
                      <input
                        type="text"
                        class="form-control required"
                        id=""
                        placeholder=""
                        v-model="quest.answer"
                      /><span class="bar"></span>
                      <label for="street">{{ quest.question }}</label>
                    </div>
                  </fieldset>
                </div>
                <!--  END TEXT  -->

                <!--  CHECK BOX  -->
                <div
                  class="col-6 m-b-40"
                  v-if="quest.questionInputTypeId === 2"
                >
                  <fieldset class="floating-labels">
                    <div
                      class="input-group"
                      style="margin-bottom: 2px !important"
                    >
                      <p class="boldText">
                        {{ quest.question }}
                      </p>
                    </div>
                  </fieldset>
                  <div class="input-group">
                    <div
                      class="row"
                      v-for="(opt, ndxA1) in quest.options"
                      :key="ndxA1"
                    >
                      <div style="margin-right: 100px">
                        <input
                          class="input1"
                          type="checkbox"
                          value="3"
                          name="checkbox"
                          id=""
                        />
                        <label
                          v-if="opt.questOptionId == quest.answer"
                          style="background-color: #00bfff"
                          for="checkbox1"
                          @click="questOptionSelected(quest, opt)"
                          class="btn"
                          >{{ opt.questOption }}</label
                        >
                        <label
                          v-else
                          for="checkbox1"
                          @click="questOptionSelected(quest, opt)"
                          class="btn btn-outline-info label2"
                          >{{ opt.questOption }}</label
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <!--  END CHECK BOX  -->

                <!--  **RATING  -->
                <div
                  class="col-6 m-b-40"
                  v-if="quest.questionInputTypeId === 3"
                >
                  <div class="form-group">
                    <p class="boldText">{{ quest.question }}</p>
                    <div class="input-group">
                      <div class="floating-labels">
                        <div class="row">
                          <div
                            class="form-group col-1 m-r-40"
                            v-for="(opt, ndxA1) in quest.options"
                            :key="ndxA1"
                          >
                            <!-- <p {{ndx01}} /> -->
                            <input
                              class="input1"
                              type="radio"
                              value="1"
                              name="radio"
                              id="radio1"
                            />
                            <label
                              v-if="opt.questOptionId == quest.answer"
                              style="background-color: #00bfff"
                              for="radio1"
                              data-toggle="tooltip"
                              data-placement="top"
                              :title="opt.questOption"
                              @click="questOptionSelected(quest, opt)"
                              :class="
                                opt.questOptionId == quest.answer
                                  ? 'btn btn-info label1'
                                  : 'btn btn-outline-info label1'
                              "
                              >O{{ ndxA1 + 1 }}</label
                            >
                            <label
                              v-else
                              for="radio1"
                              class="btn btn-outline-info label1"
                              data-toggle="tooltip"
                              data-placement="top"
                              :title="opt.questOption"
                              @click="questOptionSelected(quest, opt)"
                              >O{{ ndxA1 + 1 }}</label
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--  END RATING  -->

                <!--  **RADIO BUTTON  -->
                <div
                  class="col-6 m-b-40"
                  v-if="quest.questionInputTypeId === 4"
                >
                  <fieldset class="floating-labels">
                    <div
                      class="form-group"
                      style="margin-bottom: 2px !important"
                    >
                      <p class="boldText">
                        {{ quest.question }}
                      </p>
                    </div>
                  </fieldset>
                  <div class="input-group">
                    <div class="row">
                      <div
                        style="margin-right: 100px"
                        v-for="(opt, ndxA1) in quest.options"
                        :key="ndxA1"
                      >
                        <input
                          class="input1"
                          type="radio"
                          value="1"
                          name="radio"
                          id="radio1"
                        />
                        <label
                          v-if="opt.questOptionId == quest.answer"
                          style="background-color: #00bfff; color: black"
                          for="radio1"
                          class="btn btn-outline-info label2"
                          @click="questOptionSelected(quest, opt)"
                          >{{ opt.questOption }}</label
                        >
                        <label
                          v-else
                          for="radio1"
                          class="btn btn-outline-info label2"
                          @click="questOptionSelected(quest, opt)"
                          >{{ opt.questOption }}</label
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <!--  END RADIO BUTTON  -->

                <!--  EMAIL  -->
                <div class="col-6" v-if="quest.questionInputTypeId === 5">
                  <fieldset class="floating-labels">
                    <div
                      class="form-group m-b-40"
                      :class="[quest.question != null ? 'focused' : '']"
                    >
                      <input
                        type="text"
                        class="form-control required"
                        id=""
                        placeholder=""
                        maxlength="100"
                        v-model="quest.answer"
                      /><span class="bar"></span>
                      <label for="street">{{ quest.question }}</label>
                    </div>
                  </fieldset>
                </div>
                <!--  END EMAIL  -->

                <!--  PHONE  -->
                <div class="col-6" v-if="quest.questionInputTypeId === 6">
                  <fieldset class="floating-labels">
                    <div
                      class="form-group m-b-40"
                      :class="[quest.question != null ? 'focused' : '']"
                    >
                      <input
                        v-mask="'###-###-####'"
                        type="tel"
                        class="form-control required phone-inputmask"
                        id=""
                        placeholder=""
                        v-model="quest.answer"
                      /><span class="bar"></span>
                      <label for="street">{{ quest.question }}</label>
                    </div>
                  </fieldset>
                </div>

                <!--  DATE  -->
                <div class="col-6" v-if="quest.questionInputTypeId === 7">
                  <fieldset class="floating-labels">
                    <div
                      class="form-group"
                      style="margin-bottom: 2px !important"
                    >
                      <p class="boldText">{{ quest.question }}</p>
                    </div>
                    <div class="form-group" style="margin-top: -18px">
                      <input
                        type="date"
                        class="form-control"
                        id=""
                        v-model="quest.answer"
                      /><span class="bar"></span>
                    </div>
                  </fieldset>
                </div>
                <!--  END DATE  -->
              </div>
            </form>
          </div>
          <!--body -->
        </div>
      </div>
    </div>
    <!-- Questionnaire Modal -->

    <!-- Compose Email Modal -->
    <div
      class="modal bs-example-modal-lg fade"
      id="sendEmail1"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myLargeModalLabel"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Mailbox</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>
          </div>
          <div class="modal-body">
            <div class="container">
              <div class="row">
                <div class="col-4 col-md-4">
                  <div class="row">
                    <div class="col-xl">
                      <div
                        class="list-group text-left"
                        id="list-tab"
                        role="tablist"
                      >
                        <a
                          style="word-break: break-all;"
                          v-for="(email, ndxA03) in emailTempsList"
                          :key="ndxA03"
                          @click="emailTempsListClick(email)"
                          :class="selectedEmailTempClass(email)"
                          role="tab"
                          href="#list-home"
                          aria-selected="true"
                          ><i :class="selectedEmailTempIcon(email)"></i
                          >{{ email.name }}</a
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-8 col-md-8">
                  <form class="">
                    <div class="card-body">
                      <h3 class="card-title">Compose New Message</h3>
                      <div class="form-group">
                        <input
                          class="form-control"
                          placeholder="Template Name:"
                          maxlength="40"
                          v-model="aSingleEmail.name"
                        />
                      </div>
                      <div class="form-group">
                        <input
                          class="form-control"
                          placeholder="Send:"
                          maxlength="100"
                          v-model="aSinglePatient.email"
                        />
                      </div>
                      <div class="form-group">
                        <input
                          class="form-control"
                          placeholder="Subject:"
                          maxlength="100"
                          v-model="aSingleEmail.emailSubject"
                        />
                      </div>
                  <Editor v-model="aSingleEmail.emailText" editorStyle="height: 200px"/>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              @click="sendEmail()"
              type="button"
              class="btn btn-outline-success waves-effect waves-light col-12"
            >
              Send Email
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Compose Email Modal -->


<div
      id="displayReceipt"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      style="display: none ;z-index :1200"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Send Receipt to following details</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>
          </div>
          <div class="modal-body">
            <form class="floating-labels m-t-40">
              <div class="form-group m-b-40"
                 :class="[SendReceiptRequest.Email != '' ? 'focused' : '']">
                <input
                  type="text"
                  v-model="SendReceiptRequest.Email"
                  class="form-control"
                  id=""
                /><span class="bar"></span>
                <label for="">Email<span style="color: red"> *</span></label>
              </div>
              <div class="form-group m-b-40"
               :class="[SendReceiptRequest.Phone != '' ? 'focused' : '']">
                <input
                  v-mask="'###-###-####'"
                  type="tel"
                  v-model="SendReceiptRequest.Phone"
                  class="form-control"
                  id=""
                /><span class="bar"></span>
                <label for=""
                  >Phone Number<span style="color: red"> *</span></label
                >
              </div>
            </form>
          </div>

       <div class="modal-footer">
            <button
              type="button"
              @click="sendReceiptClick"
              class="btn btn-success waves-effect waves-light"
            >
              Send
            </button>
            <button
              type="button"
              class="btn btn-danger waves-effect waves-light"
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
       </div>
      </div>
    </div>

<div
      id="displayReceipt11"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      style="display: none; z-index:1200"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Send Receipt to following details</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>
          </div>
          <div class="modal-body">
            <form class="floating-labels m-t-40">
              <div class="form-group m-b-40"
               >
         <input  type="text" class="form-control" id="refund" tabindex="1"
          v-model="refundAmount"
         :placeholder="'Amount Refunded (In $$), can not be greater then $' + (ActivePaymentRequest.amount - ActivePaymentRequest.refundAmount)"
          aria-labelledby="cname" 
          :max="ActivePaymentRequest.amount" 
          @keypress="amountRefundCheck($event,refundAmount)"
         >
                </div>
            </form>
          </div>

       <div class="modal-footer">
            <button
              type="button"
              @click="refundPayment()"
              class="btn btn-success waves-effect waves-light"
            >
              Send
            </button>
            <button
              type="button"
              class="btn btn-danger waves-effect waves-light"
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
       </div>
      </div>
    </div>

    <!-- sendText1 Modal -->
    <div
      class="modal bs-example-modal-lg fade"
      id="sendText1"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myLargeModalLabel"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Send a text</h4>
            <button type="button" class="close" @click="sendText1ModalClose">
              ×
            </button>
          </div>
          <div class="modal-body">
            <div class="container">
              <div class="row">
                <div class="col-4 col-md-4">
                  <div class="row">
                    <div class="col-xl">
                      <div
                        class="list-group text-left"
                        id="list-tab"
                        role="tablist"
                      >
                        <a
                          style="word-break: break-all;"
                          v-for="(sms, ndxA02) in smsTempsList"
                          :key="ndxA02"
                          @click="smsTempsListClick(sms)"
                          :class="selectedSmsTempClass(sms)"
                          id="list-home-list"
                          data-toggle="list"
                          href="#list-home"
                          role="tab"
                          aria-controls="home"
                          aria-selected="true"
                          ><i :class="selectedSmsTempIcon(sms)"></i>
                          {{ sms.name }}</a
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-8 col-md-8">
                  <form class="floating-labels m-t-40">
                    <div
                      class="form-group m-b-40"
                      :class="[aSingleSms.name.length > 0 ? 'focused' : '']"
                    >
                      <span class="p-float-label">
                              <InputText
                        type="text"
                        class="form-control float-class"
                        id="templateName"
                        maxlength="40"
                        v-model="aSingleSms.name"
                      /><span class="bar"></span>
                      <label for="" id="font1">Template Name<span  style="color:red"> *</span></label>
                      </span>
                    </div>
                    <div
                      class="form-group m-b-40"
                      :class="[aSinglePatient.phone.length > 0 ? 'focused' : '']"
                    >
                      <span class="p-float-label">
                              <InputText  
                        v-mask="'###-###-####'"
                        type="tel"
                        class="form-control float-class"
                        id="to"
                        v-model="aSinglePatient.phone"
                      /><span class="bar"></span>
                      <label for="" id="font1">To<span  style="color:red"> *</span></label>
                      </span>
                    </div>
                    <div
                      class="form-group m-b-40"
                      :class="[aSingleSms.smsText.length > 0 ? 'focused' : '']"
                    >
                      <span class="p-float-label">
                              <InputText 
                        maxlength="120"
                        v-model="aSingleSms.smsText"
                        class="form-control float-class"
                        id="comment-text"
                      /><span class="bar"></span>
                      <label for="" id="font1" class="control-label"
                        >Type your text<span  style="color:red"> *</span></label>
                      </span>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-success waves-effect waves-light col-12"
              @click="SendSms()"
            >
              Send Text
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Send a Text Modal -->

    <!-- comment Modal -->
    <div
      id="CommentModal"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Leave a reply</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>
          </div>
          <div class="modal-body">
            <form>
              <div class="form-group">
                <label for="comment-text" class="control-label">Comment<span  style="color:red"> *</span>:</label>
                <textarea
                  v-model="commentText"
                  class="form-control"
                  id="comment-text"
                  autofocus
                ></textarea>
              </div>

              <div class="row mb-4">
                <button
                  type="button"
                  class="
                    btn btn-outline-success
                    waves-effect waves-light
                    col-12
                  "
                  @click="leaveCommentSaveClick"
                >
                  Leave Comment
                </button>
              </div>

              <div class="form-group">
                <div
                  class="timeline-panel"
                  v-for="(tc, ndx01) in commentsList"
                  :key="ndx01"
                >
                  <div class="timeline-heading">
                    <h4 class="" style="font-size: 20px; font-weight: 800">
                      {{ tc.commentFromName }}
                    </h4>
                    <p style="margin-top: -10px">
                      <small class="text-muted">
                        <i class="fa fa-clock-o"></i>{{ tc.commentLocalDate }}
                      </small>
                    </p>
                  </div>
                  <div class="timeline-body">
                    <p>{{ tc.commentText }}</p>
                  </div>

                  <hr v-if="showCommentLine(ndx01)" class="solid bg-white" />
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer"></div>
        </div>
      </div>
    </div>

    <!-- Edit Visit Modal -->
    <div
      id="editVisit"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Edit Visit Type</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>
          </div>
          <div class="modal-body">
            <form class="floating-labels m-t-40">
              <div
                class="form-group"
                :class="[aSinglePatient.visitTypeId != null ? 'focused' : '']"
              >
                <label class="control-label">Visit Type<span  style="color:red"> *</span></label>
                <select
                  class="form-control custom-select"
                  data-placeholder="Choose a Visit Type"
                  tabindex="1"
                  v-model="aSinglePatient.visitTypeId"
                >
                  <option
                    v-for="(type, ndx05) in visitTypes"
                    :key="ndx05"
                    :value="type.visitTypeId"
                  >
                    {{ type.visitTypeName }}
                  </option>
                </select>
              </div>
              <br />
              <div
                class="form-group"
                :class="[aSinglePatient.visitDetailId != null ? 'focused' : '']"
              >
                <label class="control-label">Visit Reason<span  style="color:red"> *</span></label>
                <select
                  class="form-control custom-select"
                  data-placeholder="Choose a Visit Reason"
                  tabindex="1"
                  v-model="aSinglePatient.visitDetailId"
                >
                  <option
                    v-for="(rea, ndx06) in activeVisitReasons"
                    :key="ndx06"
                    :value="rea.visitDetailId"
                  >
                    {{ rea.reasonName }}
                  </option>
                </select>
              </div>
            </form>
            <form>
              <div class="form-group m-b-40">
                <label class="control-label">Date of Service<span  style="color:red"> *</span></label>
                <input
                  type="date"
                  class="form-control"
                  id="dos"
                  v-model="aSinglePatient.dosStr"
                /><span class="bar"></span>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-success waves-effect waves-light col-12"
              @click="updatePatientTypeReasonClick"
            >
              Update Visit Type
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Edit Visit Modal -->

    <!--  ~~MODALS -->
    <!-- New Patients Modal newptModal-->
    <!-- $$**$$ Begin -->
    <!-- <div
      class="modal fade"
      id="newptModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      style="display: none"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog cascading-modal modal-lg">
        <div class="modal-content" style="width: 158% !important; left: -200px">
          <PatientComponent v-bind:propTarget="propPatientSource" @destroyProp = "changeVAL">
          </PatientComponent>
        </div>
      </div>
    </div> -->
    <!-- New Patients Modal newptModal-->
      <div
        class="modal fade"
        id="newptModalCom"
        tabindex="-1"
        role="dialog"
        aria-labelledby="myModalLabel"
        aria-hidden="true"
        style="display: none"
      >
      <PatientComponent :patientId="patientId" :visitId="visitId" :FetchTableData="CallFetchDataPatients" ref="patientComponent"  :AppModelId='18' v-if="showProfilePopupVar==true"></PatientComponent>
      </div>
    <div
      class="modal fade"
      id="newptModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog cascading-modal modal-lg">
        <div class="modal-content" style="width: 158% !important; left: -200px">
          <div class="modal-header">
            <h4 class="modal-title" id="myLargeModalLabel">
              {{ aSinglePatient.firstName + " " + aSinglePatient.lastName }} -
              {{ stdDate }} - {{ aSinglePatient.ptid }}
            </h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>
          </div>

          <div class="modal-body mb-1 pt-2">
            <div class="vtabs customvtab">
              <ul class="nav nav-tabs tabs-vertical" role="tablist">
                <li class="nav-item">
                  <a
                    class="nav-link text-nowrap"
                    data-toggle="tab"
                    href="#home3"
                    role="tab"
                    style="border: none"
                    ><span class="hidden-sm-up"></span>
                    <span class="hidden-xs-down" id="detailsCa">Details</span>
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    class="nav-link text-nowrap"
                    data-toggle="tab"
                    href="#customDemo3"
                    role="tab"
                    style="border: none"
                    ><span class="hidden-sm-up"></span>
                    <span class="hidden-xs-down">Custom Demo</span>
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    class="nav-link text-nowrap"
                    data-toggle="tab"
                    href="#insuranceList3"
                    role="tab"
                    style="border: none"
                    ><span class="hidden-sm-up"></span>
                    <span class="hidden-xs-down">Insurance</span>
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    class="nav-link text-nowrap"
                    data-toggle="tab"
                    href="#paymentRequestList3"
                     @click="getPaymentResTabl()"
                    role="tab"
                    style="border: none"
                    ><span class="hidden-sm-up"></span>
                    <span class="hidden-xs-down">Payment Request</span>
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    class="nav-link text-nowrap"
                    data-toggle="tab"
                    href="#visitHistory3"
                    role="tab"
                    style="border: none"
                    ><span class="hidden-sm-up"></span>
                    <span class="hidden-xs-down">Visit History</span></a
                  >
                </li>
                <li class="nav-item">
                  <a
                    id="paymentHistory"
                    class="nav-link text-nowrap"
                    data-toggle="tab"
                    href="#paymentHistory3"
                    role="tab"
                    style="border: none"
                    ><span class="hidden-sm-up"></span>
                    <span class="hidden-xs-down">Payment History</span></a
                  >
                </li>
                <!-- <li class="nav-item">
                  <a
                    id="emailHistory1221"
                    class="nav-link text-nowrap"
                    data-toggle="tab"
                    href="#emailHistory"
                    role="tab"
                    style="border: none"
                    ><span class="hidden-sm-up"></span>
                    <span class="hidden-xs-down"
                      >Email History<span class="badge badge-danger mr-1">
                      </span></span
                  ></a>
                </li>
                <li class="nav-item">
                  <a
                  @click="textHistoryClick()"
                    id="textHistory1221"
                    class="nav-link text-nowrap"
                    data-toggle="tab"
                    href="#textHistory3"
                    role="tab"
                    style="border: none"
                    ><span class="hidden-sm-up"></span>
                    <span class="hidden-xs-down"
                      >Text History<span class="badge badge-danger mr-1">
                      </span></span
                  ></a>
                </li> -->
                <!-- <li class="nav-item">
                  <a
                    class="nav-link text-nowrap"
                    data-toggle="tab"
                    href="#auditList3"
                    @click="GetAuditLog()"
                    role="tab"
                    style="border: none"
                    ><span class="hidden-sm-up"></span>
                    <span class="hidden-xs-down">History</span>
                  </a>
                </li> -->
              </ul>
              <!-- Tab panes -->
              <div class="tab-content" style="width: 100%">
                <div
                  class="tab-pane profile-tab-pane"
                  id="home3"
                  role="tabpanel"
                >
                  <button
                    class="btn btn-outline-success waves-effect col-12"
                    :disabled="updButton == 0"
                    @click="updateDetailsClick()"
                  >
                    Save
                  </button>
                  <div class="modal-body">
                    <h3 class="font-weight-bold h3Spacing">Basic Details</h3>
                    <form class="floating-labels">
                      <!-- first row 77-->
                      <div class="row">
                        <div class="col-lg-6">
                          <!-- first name -->
                          <div
                            class="form-group m-b-40"
                            :class="[
                              aSinglePatient.firstName != null ? '' : 'focused',
                            ]"
                          >
                            <span class="p-float-label">
                              <InputText
                                type="text"
                                class="form-control float-class"
                                id="firstName"
                                maxlength="50"
                                placeholder=""
                                v-model="aSinglePatient.firstName"
                              /><span class="bar"></span>
                              <label for="" id="font1"
                                >First Name<span style="color: red">
                                  *</span
                                ></label
                              >
                            </span>
                          </div>
                          <!-- first name -->
                        </div>
                        <div class="col-lg-6">
                          <!-- last name -->
                          <div
                            class="form-group m-b-40"
                            :class="[
                              aSinglePatient.lastName != null ? '' : 'focused',
                            ]"
                          >
                            <span class="p-float-label">
                              <InputText
                                type="text"
                                class="form-control float-class"
                                id="lastName"
                                placeholde=""
                                maxlength="50"
                                v-model="aSinglePatient.lastName"
                              /><span class="bar"></span>
                              <label for="" id="font1"
                                >Last Name<span style="color: red">
                                  *</span
                                ></label
                              >
                            </span>
                          </div>
                          <!-- last name -->
                        </div>
                      </div>
                      <!-- first row -->

                      <!-- second row *77*-->
                      <div class="row">
                        <div class="col-lg-6">
                          <div
                            class="form-group m-b-40"
                            :class="[
                              aSinglePatient.dob != null ? 'focused' : '',
                            ]"
                          >
                            <input
                              type="date"
                              class="form-control"
                              id="dob"
                              placeholder=""
                              v-model="aSinglePatient.dob"
                            /><span class="bar"></span>
                            <label
                              for=""
                              style="
                                font-weight: bold;
                                margin-left: 2px;
                              "
                              >Date of Birth<span style="color: red">
                                *</span
                              ></label
                            >
                          </div>
                        </div>

                        <div class="col-lg-6">
                          <div
                            class="form-group m-b-40"
                            :class="[
                              aSinglePatient.gender != null ? 'focused' : '',
                            ]"
                          >
                            <select
                              class="form-control custom-select"
                              tabindex="1"
                              v-model="aSinglePatient.gender"
                            >
                              <option value="0">Choose a Gender</option>
                              <option value="Male">Male</option>
                              <option value="Female">Female</option>
                              <option value="Other">Others</option> </select
                            ><span class="bar"></span>
                            <label
                              for=""
                              style="
                                font-weight: bold;
                                margin-left: 2px;
                              "
                              >Gender<span style="color: red"> *</span></label
                            >
                          </div>
                        </div>
                      </div>
                      <!-- second row -->

                      <!-- fourth row -->
                      <div class="row">
                        <div class="col-lg-6">
                          <div
                            class="form-group m-b-40"
                            :class="[
                              aSinglePatient.externalId != null
                                ? ''
                                : 'focused',
                            ]"
                          >
                            <span class="p-float-label">
                              <InputText
                                type="text"
                                class="form-control float-class"
                                id="extrnalid"
                                placeholder=""
                                v-model="aSinglePatient.externalId"
                              /><span class="bar"></span>
                              <label for="" id="font1">External ID</label>
                            </span>
                          </div>
                        </div>
                        <div class="col-lg-6">
                          <div
                            class="form-group m-b-40"
                            :class="[
                              aSinglePatient.ssn != null ? '' : 'focused',
                            ]"
                          >
                            <span class="p-float-label">
                              <InputText
                                v-mask="'###-##-####'"
                                type="tel"
                                class="form-control float-class"
                                id="ssns1"
                                placeholder=""
                                v-model="aSinglePatient.ssn"
                              /><span class="bar"></span>
                              <label for="" id="font1"
                                >Social Security Number
                              </label>
                            </span>
                          </div>
                        </div>
                      </div>
                      <!-- fourth row -->

                      <h3 class="font-weight-bold h3Spacing">
                        Contact Information
                      </h3>
                      <!-- third row -->
                      <div class="row">
                        <div class="col-lg-6">
                          <div
                            class="form-group m-b-40"
                            :class="[
                              aSinglePatient.phone != null ? '' : 'focused',
                            ]"
                          >
                            <span class="p-float-label">
                              <InputText
                                type="tel"
                                class="form-control float-class"
                                id="Phones1"
                                v-mask="'###-###-####'"
                                v-model="aSinglePatient.phone"
                              /><span class="bar"></span>
                              <label for="" id="font1">Phone Number </label>
                            </span>
                          </div>
                        </div>
                        <div class="col-lg-6">
                          <div
                            class="form-group m-b-40"
                            :class="[
                              aSinglePatient.email != null ? '' : 'focused',
                            ]"
                          >
                            <span class="p-float-label">
                              <InputText
                                type="email"
                                class="form-control float-class"
                                id="emails1"
                                placeholder=""
                                maxlength="50"
                                v-model="aSinglePatient.email"
                              /><span class="bar"></span>
                              <label for="" id="font1">Email</label>
                            </span>
                          </div>
                        </div>
                      </div>
                      <!-- third row -->

                      <h3 class="font-weight-bold h3Spacing">Address</h3>
                      <!-- fifth row -->
                      <div class="row">
                        <div class="col-lg-6">
                          <div
                            class="form-group m-b-40"
                            :class="[
                              this.aSinglePatient.address != null
                                ? ''
                                : 'focused',
                            ]"
                          >
                            <span class="p-float-label">
                              <InputText
                                type="text"
                                class="form-control float-class"
                                id="streets1"
                                maxlength="100"
                                placeholder=""
                                v-model="aSinglePatient.address"
                              /><span class="bar"></span>
                              <label for="" id="font1">Street</label>
                            </span>
                          </div>
                        </div>
                        <div class="col-lg-6">
                          <div
                            class="form-group m-b-40"
                            :class="[
                              aSinglePatient.city != null ? '' : 'focused',
                            ]"
                          >
                            <span class="p-float-label">
                              <InputText
                                type="text"
                                class="form-control float-class"
                                id="citys1"
                                placeholder=""
                                maxlength="50"
                                v-model="aSinglePatient.city"
                              /><span class="bar"></span>
                              <label for="" id="font1">City</label>
                            </span>
                          </div>
                        </div>

                        <div class="col-lg-6">
                          <div
                            class="form-group m-b-40"
                            :class="[
                              aSinglePatient.zip != null ? '' : 'focused',
                            ]"
                          >
                            <span class="p-float-label">
                              <InputText
                                type="text"
                                class="form-control float-class"
                                id="zips1"
                                maxlength="5"
                                placeholder=""
                                v-model="aSinglePatient.zip"
                              /><span class="bar"></span>
                              <label for="" id="font1">Zip</label>
                            </span>
                          </div>
                        </div>

                        <div class="col-lg-6">
                          <div
                            class="form-group m-b-40"
                            :class="[
                              aSinglePatient.state != null ? '' : 'focused',
                            ]"
                          >
                            <span class="p-float-label">
                              <select
                                class="form-control custom-select"
                                tabindex="1"
                                v-model="aSinglePatient.state"
                              >
                                <option value="">Choose State</option>
                                <option value="FL">FL</option>
                                <option value="AL">AL</option>
                                <option value="AK">AK</option>
                                <option value="AZ">AZ</option>
                                <option value="AR">AR</option>
                                <option value="CA">CA</option>
                                <option value="CO">CO</option>
                                <option value="CT">CT</option>
                                <option value="DE">DE</option>
                                <option value="GA">GA</option>
                                <option value="HI">HI</option>
                                <option value="ID">ID</option>
                                <option value="IL">IL</option>
                                <option value="IN">IN</option>
                                <option value="IA">IA</option>
                                <option value="KS">KS</option>
                                <option value="KY">KY</option>
                                <option value="ME">ME</option>
                                <option value="MD">MD</option>
                                <option value="MA">MA</option>
                                <option value="MI">MI</option>
                                <option value="MN">MN</option>
                                <option value="MS">MS</option>
                                <option value="MO">MO</option>
                                <option value="MT">MT</option>
                                <option value="NE">NE</option>
                                <option value="NV">NV</option>
                                <option value="NH">NH</option>
                                <option value="NJ">NJ</option>
                                <option value="NM">NM</option>
                                <option value="NY">NY</option>
                                <option value="NC">NC</option>
                                <option value="ND">ND</option>
                                <option value="OH">OH</option>
                                <option value="OK">OK</option>
                                <option value="OR">OR</option>
                                <option value="PA">PA</option>
                                <option value="RI">RI</option>
                                <option value="SC">SC</option>
                                <option value="SD">SD</option>
                                <option value="TN">TN</option>
                                <option value="TX">TX</option>
                                <option value="UT">UT</option>
                                <option value="VT">VT</option>
                                <option value="VA">VA</option>
                                <option value="WA">WA</option>
                                <option value="WV">WV</option>
                                <option value="WI">WI</option>
                                <option value="WY">WY</option>
                              </select>
                              <label for="" id="font1" style="margin-top: -31px"
                                >State</label
                              >
                            </span>
                          </div>
                        </div>
                      </div>
                      <!-- fifth row -->
                    </form>
                  </div>
                </div>
                <div
                  class="tab-pane profile-tab-pane"
                  id="customDemo3"
                  role="tabpanel"
                >
                  <!-- <button
                    class="btn btn-outline-success waves-effect col-12"
                    :disabled="updButton == 0"
                    @click="demoSaveClick"
                  >
                    Save
                  </button> -->
                  <div class="modal-body">
                    <form>
                      <div
                        class="row"
                        v-for="(demo, ndx07) in visitDemo"
                        :key="ndx07"
                      >
                        <!--  TEXT  -->
                        <div
                          class="col-12"
                          v-if="demo.questionInputTypeId == 1"
                        >
                          <fieldset class="floating-labels">
                            <div
                              class="form-group"
                              style="margin-bottom: 2px !important"
                            >
                              <p class="boldText">
                                {{ demo.question }}
                              </p>
                            </div>
                            <div
                              class="form-group m-b-40"
                              style="margin-top: -18px"
                            >
                              <input
                                type="text"
                                class="form-control required"
                                id=""
                                placeholder=""
                                v-model="demo.answer"
                              /><span class="bar"></span>
                            </div>
                          </fieldset>
                        </div>
                        <!--  END TEXT  -->

                        <!--  *-*CHECK BOX  -->
                        <div
                          class="col-12 m-b-40"
                          v-if="demo.questionInputTypeId === 2"
                        >
                          <fieldset class="floating-labels">
                            <div
                              class="input-group"
                              style="margin-bottom: 2px !important"
                            >
                              <p class="boldText">
                                {{ demo.question }}
                              </p>
                            </div>
                          </fieldset>
                          <div class="input-group">
                            <div
                              class="row"
                              v-for="(opt, ndxA1) in demo.options"
                              :key="ndxA1"
                            >
                              <div style="margin-right: 100px">
                                <input
                                  class="input1"
                                  type="checkbox"
                                  value="3"
                                  name="checkbox"
                                  id=""
                                />
                                <!-- <label
                                  v-if="opt.questOptionId == demo.answer"
                                  style="background-color: #00bfff"
                                  for="checkbox1"
                                  @click="demoOptionSelected(demo, opt, 'check-box')"
                                  class="btn"
                                  >{{ opt.questOption }}</label
                                > -->
                                <label
                                  for="checkbox1"
                                  @click="
                                    demoOptionSelected(demo, opt, 'check-box')
                                  "
                                  :class="
                                    demo.answer.includes(opt.questOptionId)
                                      ? 'btn btn-info label1'
                                      : 'btn btn-outline-info label1'
                                  "
                                  >{{ opt.questOption }}</label
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                        <!--  END CHECK BOX  -->

                        <!--  RATING  -->
                        <div
                          class="col-6 m-b-40"
                          v-if="demo.questionInputTypeId === 3"
                        >
                          <div class="form-group">
                            <p class="boldText">{{ demo.question }}</p>
                            <div class="input-group">
                              <div class="floating-labels">
                                <div class="row">
                                  <div
                                    class="form-group col-1 m-r-40"
                                    v-for="(opt, ndxA1) in demo.options"
                                    :key="ndxA1"
                                  >
                                    <input
                                      class="input1"
                                      type="radio"
                                      value="1"
                                      name="radio"
                                      id="radio1"
                                    />
                                    <label
                                      v-if="opt.questOptionId == demo.answer"
                                      style="background-color: #00bfff"
                                      for="radio1"
                                      class="btn label1"
                                      data-toggle="tooltip"
                                      data-placement="top"
                                      :title="opt.questOption"
                                      @click="demoOptionSelected(demo, opt)"
                                      :class="
                                        opt.questOptionId == demo.answer
                                          ? 'btn btn-info label1'
                                          : 'btn btn-outline-info label1'
                                      "
                                      >O{{ ndxA1 + 1 }}</label
                                    >
                                    <label
                                      v-else
                                      for="radio1"
                                      class="btn btn-outline-info label1"
                                      data-toggle="tooltip"
                                      data-placement="top"
                                      :title="opt.questOption"
                                      @click="demoOptionSelected(demo, opt)"
                                      >O{{ ndxA1 + 1 }}</label
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!--  END RATING  -->

                        <!--  RADIO BUTTON  -->
                        <div
                          class="col-6 m-b-40"
                          v-if="demo.questionInputTypeId === 4"
                        >
                          <fieldset class="floating-labels">
                            <div
                              class="form-group"
                              style="margin-bottom: 2px !important"
                            >
                              <p class="boldText">
                                {{ demo.question }}
                              </p>
                            </div>
                          </fieldset>
                          <div class="input-group">
                            <div class="row">
                              <div
                                style="margin-right: 100px"
                                v-for="(opt, ndxA1) in demo.options"
                                :key="ndxA1"
                              >
                                <input
                                  class="input1"
                                  type="radio"
                                  value="1"
                                  name="radio"
                                  id="radio1"
                                />
                                <label
                                  v-if="opt.questOptionId == demo.answer"
                                  style="
                                    background-color: #00bfff;
                                    color: black;
                                  "
                                  for="radio1"
                                  class="btn btn-outline-info label2"
                                  @click="demoOptionSelected(demo, opt)"
                                  >{{ opt.questOption }}</label
                                >
                                <label
                                  v-else
                                  for="radio1"
                                  class="btn btn-outline-info label2"
                                  @click="demoOptionSelected(demo, opt)"
                                  >{{ opt.questOption }}</label
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                        <!--  END RADIO BUTTON  -->

                        <!--  EMAIL  -->
                        <div
                          class="col-6"
                          v-if="demo.questionInputTypeId === 5"
                        >
                          <fieldset class="floating-labels">
                            <div
                              class="form-group"
                              style="margin-bottom: 2px !important"
                            >
                              <p class="boldText">
                                {{ demo.question }}
                              </p>
                            </div>
                            <div
                              class="form-group m-b-40"
                              style="margin-top: -18px"
                            >
                              <input
                                type="text"
                                class="form-control required"
                                id=""
                                placeholder=""
                                maxlength="100"
                                v-model="demo.answer"
                              /><span class="bar"></span>
                            </div>
                          </fieldset>
                        </div>
                        <!--  END EMAIL  -->

                        <!--  PHONE  -->
                        <div
                          class="col-6"
                          v-if="demo.questionInputTypeId === 6"
                        >
                          <fieldset class="floating-labels">
                            <div
                              class="form-group m-b-40"
                              :class="[demo.answer != null ? 'focused' : '']"
                            >
                              <input
                                type="tel"
                                class="form-control required phone-inputmask"
                                id=""
                                placeholder=""
                                v-model="demo.answer"
                              /><span class="bar"></span>
                              <label for="street">{{ demo.question }}</label>
                            </div>
                          </fieldset>
                        </div>

                        <!--  DATE  -->
                        <div
                          class="col-6"
                          v-if="demo.questionInputTypeId === 7"
                        >
                          <fieldset class="floating-labels">
                            <div
                              class="form-group"
                              style="margin-bottom: 2px !important"
                            >
                              <p class="boldText">{{ demo.question }}</p>
                            </div>
                            <div class="form-group" style="margin-top: -18px">
                              <input
                                type="date"
                                class="form-control"
                                id=""
                                v-model="demo.answer"
                              /><span class="bar"></span>
                            </div>
                          </fieldset>
                        </div>
                        <!--  END DATE  -->
                      </div>
                    </form>
                  </div>
                </div>
                 <div
                  class="tab-pane profile-tab-pane"
                  id="insuranceList3"
                  role="tabpanel"
                >
                  <button
                    class="btn btn-outline-success waves-effect col-12"
                    :disabled="updButton == 0"
                    @click="saveInsuranceClick"
                  >
                    Save
                  </button>
                  <div class="modal-body">
                    <h3 class="font-weight-bold h3Spacing">
                      Primary Insurance
                    </h3>
                    <form class="floating-labels"> 
                      <!-- first row -->
                      <div class="row">
                        <div class="col-lg-6"> 
                          <!-- Primary Insurance -->
                           <div
                            class="form-group m-b-40"
                            v-bind:class="[
                              insurance.primaryInsurance.length >
                              0
                                ? 'focused'
                                : '',
                            ]"
                          >
                            <span class="p-float-label">
                              <InputText
                                type="text"
                                class="form-control float-class"
                                id="pinsur"
                                placeholder=""
                                maxlength="100"
                                v-model="
                                  insurance.primaryInsurance
                                "
                              /><span class="bar"></span>
                              <label for="" id="font1">
                                Primary Insurance
                              </label>
                            </span>
                          </div> 
                          <!-- Primary Insurance -->
                       </div>
                        <div class="col-lg-6"> 
                          <!-- Primary Insurance Number -->
                           <div
                            class="form-group m-b-40"
                            v-bind:class="[
                              insurance.primaryInsuranceNo !=
                              null
                                ? ''
                                : 'focused',
                            ]"
                          >
                            <span class="p-float-label">
                              <InputText
                                type="text"
                                class="form-control float-class"
                                id="pinsNo"
                                placeholder=""
                                maxlength="50"
                                v-model="
                                  insurance.primaryInsuranceNo
                                "
                              /><span class="bar"></span>
                              <label for="" id="font1"
                                >Primary Insurance Number
                              </label>
                            </span>
                          </div> 
                          <!-- Primary Insurance Number -->
                        </div>
                        <div class="col-lg-6"> 
                          <!-- Primary Insurance Group ID -->
                           <div
                            class="form-group m-b-40"
                            v-bind:class="[
                              insurance.primaryInsuranceGroupId
                                .length > 0
                                ? 'focused'
                                : '',
                            ]"
                          >
                            <span class="p-float-label">
                              <InputText
                                type="text"
                                class="form-control float-class"
                                id="insG"
                                placeholder=""
                                maxlength="50"
                                v-model="
                                  insurance
                                    .primaryInsuranceGroupId
                                "
                              /><span class="bar"></span>
                              <label for="" id="font1"
                                >Primary Insurance Group ID
                              </label>
                            </span>
                          </div> 
                        </div>
                        <!-- <div class="col-lg-6">  -->
                          <!-- Insurance ID -->
                          <!-- <div class="form-group m-b-40">
                            <input
                              type="file"
                              class="custom-file-input"
                              id="customFileLang_f"
                            />
                            <label
                              class="custom-file-label"
                              for="customFileLang"
                              id="customFileLang_fl"
                              >{{
                              insurance.primaryInsuranceId
                              }}</label
                            >
                          </div>  -->
                          <!-- Insurance ID -->
                         <!-- </div> -->
                      </div> 
                      <!-- first row -->
                    </form>

                    <h3 class="font-weight-bold h3Spacing">
                      Secondary Insurance
                    </h3>
                    <form class="floating-labels"> 
                      <!-- first row -->
                      <div class="row">
                        <div class="col-lg-6"> 
                          <!-- Secondary Insurance -->
                           <div
                            class="form-group m-b-40"
                            v-bind:class="[
                              insurance.secondaryInsurance
                                .length > 0
                                ? 'focused'
                                : '',
                            ]"
                          >
                            <span class="p-float-label">
                              <InputText
                                type="text"
                                class="form-control float-class"
                                id="Sinsurance"
                                placeholder=""
                                maxlength="100"
                                v-model="
                                  insurance.secondaryInsurance
                                "
                              /><span class="bar"></span>
                              <label for="" id="font1"
                                >Secondary Insurance
                              </label>
                            </span>
                          </div> 
                          <!-- Secondary Insurance -->
                        </div>
                        <div class="col-lg-6"> 
                          <!-- Secondary Insurance Number -->
                           <div
                            class="form-group m-b-40"
                            v-bind:class="[
                              insurance.secondaryInsuranceNo !=
                              null
                                ? ''
                                : 'focused',
                            ]"
                          >
                            <span class="p-float-label">
                              <InputText
                                type="text"
                                class="form-control float-class"
                                aria-labelledby="inuranceNo"
                                placeholder=""
                                maxlength="50"
                                v-model="
                                  insurance.secondaryInsuranceNo
                                "
                              /><span class="bar"></span>
                              <label for="" id="font1"
                                >Secondary Insurance Number
                              </label>
                            </span>
                          </div> 
                          <!-- Secondary Insurance Number -->
                        </div>
                        <div class="col-lg-6"> 
                          <!-- Secondary Insurance Group ID -->
                          <div
                            class="form-group m-b-40"
                            v-bind:class="[
                              insurance.secondaryInsuranceGroupId
                                .length > 0
                                ? 'focused'
                                : '',
                            ]"
                          >
                            <span class="p-float-label">
                              <InputText
                                type="text"
                                class="form-control float-class"
                                id="SinsuG"
                                placeholder=""
                                maxlength="50"
                                v-model="
                                  insurance
                                    .secondaryInsuranceGroupId
                                "
                              /><span class="bar"></span>
                              <label for="" id="font1"
                                >Secondary Insurance Group ID
                              </label>
                            </span>
                          </div>
                          <!-- Secondary Insurance Group ID -->
                        </div>
                        <!-- <div class="col-lg-6"> -->
                          <!-- Insurance ID -->
                          <!-- <div class="form-group m-b-40">
                            <input
                              type="file"
                              class="custom-file-input"
                              id="customFileLang_s"
                            />
                            <label
                              class="custom-file-label"
                              for="customFileLang"
                              id="customFileLang_sl"
                            >
                              {{
                                insurance.secondaryInsuranceId
                              }}</label
                            >
                          </div> -->
                          <!-- Insurance ID -->
                        <!-- </div> -->
                      </div>
                      <!-- first row -->
                    </form>
                  </div>
                </div>
          <div style="width: 1000px;" class="tab-pane profile-tab-pane"
                  id="paymentRequestList3"
                  role="tabpanel">
               <div class="table-responsive">
              <div
                class="
                  dataTables_wrapper     
                  no-footer
                "
              >
                <div class="dataTables_length">
                  <span style="margin-right: 10px"
                    ><label for="">Show </label>
                  </span>
                  <select
                    v-model="pageSize"
                    class="form-control form-control-sm"
                    aria-label="Default select example"
                    @change="pageChangePayment(1)"
                  >
                    <option selected>50</option>
                    <option value="100">100</option>
                    <option value="500">500</option>
                    <option value="1000">1000</option>
                    <option value="2000">2000</option>
                  </select>

                  <span style="margin-left: 10px">
                    <label for=""> Entries </label></span
                  >
                </div>
              </div>
                 <table
                      id="paym"
                      class="table display table-bordered table-striped no-wrap"
                    >
                <thead class="thead-dark">
                  <tr>
                    <th style="text-align: start">
                      Action 
                      <span>
                        <button class="asc-desc-btn" @click="orderByPay(1)">
                          &uarr; &darr;
                        </button>
                      </span>
                    </th>
                    <th style="text-align: start">
                      Status
                      <span>
                        <button class="asc-desc-btn" @click="orderByPay(2)">
                          &uarr; &darr;
                        </button>
                      </span>
                    </th>
                    <th style="text-align: start">
                      Patient Name
                      <span>
                        <button class="asc-desc-btn" @click="orderByPay(3)">
                          &uarr; &darr;
                        </button>
                      </span>
                    </th>
                    <th style="text-align: start">
                      Confirmation Number
                      <span>
                        <button class="asc-desc-btn" @click="orderByPay(4)">
                          &uarr; &darr;
                        </button>
                      </span>
                    </th>
                    <th style="text-align: start">
                      PaymentID
                      <span>
                        <button class="asc-desc-btn" @click="orderByPay(5)">
                          &uarr; &darr;
                        </button>
                      </span>
                    </th>
                    <th style="text-align: start">
                      Date of Service
                      <span>
                        <button class="asc-desc-btn" @click="orderByPay(6)">
                          &uarr; &darr;
                        </button>
                      </span>
                    </th>
                    <th style="text-align: start">
                      Date Requested
                      <span>
                        <button class="asc-desc-btn" @click="orderByPay(7)">
                          &uarr; &darr;
                        </button>
                      </span>
                    </th>
                    <th style="text-align: start">
                      Sent to
                      <span>
                        <button class="asc-desc-btn" @click="orderByPay(8)">
                          &uarr; &darr;
                        </button>
                      </span>
                    </th>
                    <th style="text-align: start">
                      Amount Requested
                      <span>
                        <button class="asc-desc-btn" @click="orderByPay(9)">
                          &uarr; &darr;
                        </button>
                      </span>
                    </th>
                    <th style="text-align: start">
                      Refund Amount
                      <span>
                        <button class="asc-desc-btn" @click="orderByPay(10)">
                          &uarr; &darr;
                        </button>
                      </span>
                    </th>
                    <th style="text-align: start">
                      Note
                      <span>
                        <button class="asc-desc-btn" @click="orderByPay(11)">
                          &uarr; &darr;
                        </button>
                      </span>
                    </th>
                  </tr>
                </thead>

                <tbody>
                    <!-- <tr v-if="filteredPaymentRequests.length == 0">
                      <td align="center" colspan="100">
                        <strong> No data available</strong>
                      </td>
                    </tr> -->
                  <tr
                    v-for="(pay, ndx01) in filteredPaymentRequests"
                    :key="ndx01"
                  >
                     <td>
                      <div class="btn-group">
                        <!-- First Button -->
                        <button
                          v-if="pay.status == 1"
                          type="button"
                          class="btn btn-success"
                          :style="colorStyle(pay.status)"
                          @click="paymentCollectMethodModal(pay)"
                        >
                          <strong>Collect Payment </strong>
                        </button>
                        <button
                          v-else-if="pay.status == 2"
                          type="button"
                          class="btn btn-success"
                          :style="colorStyle(pay.status)"
                          @click="paymentCollectMethodModal(pay)"
                        >
                          <strong>Collect Payment </strong>
                        </button>
                        <button
                          v-else-if="pay.status == 5"
                          type="button"
                          class="btn btn-success"
                            :style="colorStyle(pay.status)"
                          @click="sendReceipt(pay)"
                        >
                          <strong>Receipt </strong>
                        </button>
                        <button
                          v-else-if="pay.status == 3"
                          type="button"
                          class="btn btn-success"
                            :style="colorStyle(pay.status)"
                          @click="paymentCollectMethodModal(pay)"
                        >
                          <strong>Reminder</strong>
                        </button>
                        <button
                          v-else-if="pay.status == 4"
                          type="button"
                          class="btn btn-success"
                            :style="colorStyle(pay.status)"
                          @click="showSubmitRefundModal(pay)"
                        >
                          <strong>Refund </strong>
                        </button>
                        <button
                          v-else-if="pay.status == 6"
                          type="button"
                          class="btn btn-success"
                            :style="colorStyle(pay.status)"
                          @click="showSubmitRefundModal(pay)"
                        >
                          <strong>Refund </strong>
                        </button>
                        <button
                          v-else-if="pay.status == 7"
                          type="button"
                          class="btn btn-success"
                            :style="colorStyle(pay.status)"
                          @click="paymentCollectMethodModal(pay)"
                        >
                          <strong>Collect Payment </strong>
                        </button>
                        <button
                          v-else-if="pay.status == 9"
                          type="button"
                          class="btn btn-success"
                          :style="colorStyle(pay.status)"
                          @click="showSubmitRefundModal(pay)"
                        >
                          <strong> Refund</strong>
                        </button>
                        <button
                          v-if="updButton == 1"
                          type="button"
                          class="
                            btn btn-success
                            dropdown-toggle dropdown-toggle-split
                          "
                          :style="colorStyle(pay.status)"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          <span class="sr-only">Toggle Dropdown</span>
                        </button>
                        <button
                          v-else
                          type="button"
                          class="
                            btn btn-success
                            dropdown-toggle dropdown-toggle-split
                          "
                          :style="colorStyle(pay.status)"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                          :disabled="updButton == 0"
                        >
                          <span class="sr-only">Toggle Dropdown</span>
                        </button>
                        <div v-if="pay.status==4" class="dropdown-menu animated flipInY">
                          <a
                            class="dropdown-item"
                            href="javascript:void(0)"
                            @click="sendReceipt(pay)"
                            >Receipt</a
                          >
                           <a
                            class="dropdown-item"
                            href="javascript:void(0)"
                            @click="showReconcileModel(pay)"
                            >Reconciled</a
                          >
                        </div>
                        <div v-else-if="pay.status==6" class="dropdown-menu animated flipInY">
                          <a
                            class="dropdown-item"
                            href="javascript:void(0)"
                            @click="sendReceipt(pay)"
                            >Receipt</a
                          >
                        </div>
                        <div v-if="pay.status==9" class="dropdown-menu animated flipInY">
                        <a
                            class="dropdown-item"
                            href="javascript:void(0)"
                            @click="sendReceipt(pay)"
                            >Receipt</a
                          >
                          <a
                            v-if=" pay.status==1"
                            class="dropdown-item"
                            href="javascript:void(0)"
                            @click="deletePayment(pay)"
                            >Delete</a
                          >
                        </div>
                        <div v-else class="dropdown-menu animated flipInY">
                          <a
                            class="dropdown-item"
                            href="javascript:void(0)"
                            @click="showReminderModel(pay)"
                            >Reminder</a
                          >
                          <a
                            v-if=" pay.status==1"
                            class="dropdown-item"
                            href="javascript:void(0)"
                            @click="deletePayment(pay)"
                            >Delete</a
                          >
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="form-group" >
                        <span
                          v-if="pay.status == 1"
                          class="bs-label label-danger badgeBorder"
                         :style="colorStyle(pay.status)"
                        >
                          Requested
                        </span>
                        <span
                          v-else-if="pay.status == 2"
                          class="bs-label label-danger badgeBorder"
                          :style="colorStyle(pay.status)"
                        >
                          Pending
                        </span>
                        <span
                          v-else-if="pay.status == 3"
                          class="bs-label label-danger badgeBorder"
                          :style="colorStyle(pay.status)"
                        >
                          Disputed
                        </span>
                        <span
                          v-else-if="pay.status == 4"
                          class="bs-label label-danger badgeBorder"
                         :style="colorStyle(pay.status)"
                        >
                          Paid
                        </span>
                        <span
                          v-else-if="pay.status == 5"
                          class="bs-label label-danger badgeBorder"
                          :style="colorStyle(pay.status)"
                        >
                          Refunded
                        </span>
                        <span
                          v-else-if="pay.status == 6"
                         class="btn btn-success"
                          :style="colorStyle(pay.status)"
                        >
                          Partially Refunded
                        </span>
                        
                        <p
                          v-else-if="pay.status == 7"
                          class="bs-label label-danger badgeBorder"
                          :style="colorStyle(pay.status)"
                        >
                          Partially Paid
                        </p>
                          <p
                          v-else-if="pay.status == 9"
                          class="bs-label label-danger badgeBorder"
                          :style="colorStyle(pay.status)"
                        >
                          Reconciled
                        </p>
                      </div>
                    </td>
                    <td>{{ pay.firstName + " " + pay.lastName }}</td>
                    <td>
                      <div>
                        <span class="bs-label label-danger badgeBorder"
                        :style="colorStyle(pay.status)">
                          BID{{ pay.billNo }}
                        </span>
                      </div>
                    </td>
                    <td>
                      <div>
                        <span class="bs-label label-danger badgeBorder"
                        :style="colorStyle(pay.status)"
                        >
                          PYI{{ pay.pndx }}
                        </span>
                      </div>
                    </td>
                    <td>{{ pay.dosStr }}</td>
                    <td>{{ pay.billDateStr }}</td>
                    <td>
                      <div>
                        <span class="bs-label label-danger badgeBorder"
                          :style="colorStyle(pay.status)">
                          {{ pay.email }}
                        </span>
                      </div>
                      <br />
                      <div>
                        <span class="bs-label label-danger badgeBorder"
                          :style="colorStyle(pay.status)">
                          {{ pay.phone }}
                        </span>
                      </div>
                    </td>
                    <td>
                      ${{ pay.amount }} <br />
                      {{ pay.paymentmethodStr }}
                      <span v-if="pay.paymentMethod == 1"> Processed </span>
                      <span v-else-if="pay.paymentMethod == 0"> </span>
                      <span v-else> Collected </span>
                      {{ pay.paymentDateStr }}
                    </td>
                    <td>${{ pay.refundAmount }} <br />
                    <span> {{ pay.refundDateStr }} </span>
                    </td>
                    <td>
                      {{ pay.comment }}<br />
                      <a
                        v-if="pay.uploadedFileUrl !== ''"
                        :href="pay.uploadedFileUrl"
                      >
                        View Attachment
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <nav aria-label="Page navigation">
              <span
                style="padding-left: 40px"
                v-if="totalRowsPays < pageSizePays * pageNumberPays"
                >showing {{ totalRowsPays }} of {{ totalRowsPays }} records</span
              >
              <span style="padding-left: 40px" v-else
                >showing {{ pageSizePays * pageNumberPays }} of
                {{ totalRowsPays }} records</span
              >
              <ul class="pagination" style="float: right">
                <li class="page-item colorActive">
                  <span v-if="pageNumberPays == 1">
                    <button
                      disabled
                      class="page-link disabledColor"
                      @click="pageChangePayment('Previous')"
                    >
                      Previous
                    </button>
                  </span>
                  <span v-else>
                    <button class="page-link" @click="pageChangePayment('Previous')">
                      Previous
                    </button>
                  </span>
                </li>

                <li
                  v-for="pageNumPay in totalPagesPays"
                  :key="pageNumPay"
                  class="page-item colorActive"
                >
                  <span v-if="pageNumberPays == pageNumPay"
                    ><button
                      class="page-link activeColor"
                      disabled
                      @click="pageChangePayment(pageNumPay)"
                    >
                      {{ pageNumPay }}
                    </button>
                  </span>
                  <span v-else>
                    <button class="page-link" @click="pageChangePayment(pageNumPay)">
                      {{ pageNumPay }}
                    </button></span
                  >
                </li>

                <li class="page-item colorActive">
                  <span v-if="pageNumberPays == totalPagesPays">
                    <button
                      disabled
                      class="page-link disabledColor"
                      @click="pageChangePayment('Next')"
                    >
                      Next
                    </button>
                  </span>
                  <span v-else>
                    <button class="page-link" @click="pageChangePayment('Next')">
                      Next
                    </button>
                  </span>
                </li>
              </ul>
            </nav>
          </div> 
                <div
                  class="tab-pane"
                  id="visitHistory3"
                  role="tabpanel"
                  style="overflow: hidden"
                >
                  <div class="row justify-content-end">
                    <div class="col-sm-4" style="left: -30px !important">
                      <div class="input-group mb-3">
                        <div class="col-sm-4">
                          <input
                            style="margin-bottom: 6px; margin-left: 51px"
                            type="text"
                            name="daterange"
                            :value="initDate_2"
                            @change="datePicker_2"
                            @focus="datePicker_2"
                          />
                          <div class="input-group-append">
                            <span
                              class="input-group-text"
                              style="
                                position: absolute;
                                margin-top: -34px;
                                margin-left: 230px;
                              "
                            >
                              <span class="ti-calendar"></span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="container" style="width: 933px">
                     <div class="table-responsive">
                      <div
                        class="
                          dataTables_wrapper
                          container-fluid
                          dt-bootstrap4
                          no-footer
                        "
                      >
                        <div class="dataTables_length">
                          <span style="margin-right: 10px"
                            ><label for="">Show </label>
                          </span>
                          <select
                            v-model="VhpageSize"
                            class="form-control form-control-sm"
                            aria-label="Default select example"
                            @change="VhpageChange(1)"
                          >
                            <option selected>50</option>
                            <option value="100">100</option>
                            <option value="500">500</option>
                            <option value="1000">1000</option>
                            <option value="2000">2000</option>
                          </select>

                          <span style="margin-left: 10px">
                            <label for=""> Entries </label></span
                          >
                        </div>
                      </div>
                      <table
                        id="visitm"
                        class="
                          table
                          display
                          table-bordered table-striped
                          no-wrap
                        "
                      >
                        <thead class="thead-dark">
                          <tr>
                            <th style="text-align: start">
                              Visit Type<span>
                                <button
                                  class="asc-desc-btn"
                                  @click="VhOrderBy(1)"
                                >
                                  &uarr; &darr;
                                </button>
                              </span>
                            </th>
                            <th style="text-align: start">
                              Reason<span>
                                <button
                                  class="asc-desc-btn"
                                  @click="VhOrderBy(2)"
                                >
                                  &uarr; &darr;
                                </button>
                              </span>
                            </th>
                            <th style="text-align: start">
                              DOS<span>
                                <button
                                  class="asc-desc-btn"
                                  @click="VhOrderBy(3)"
                                >
                                  &uarr; &darr;
                                </button>
                              </span>
                            </th>
                            <th style="text-align: start">
                              Time In<span>
                                <button
                                  class="asc-desc-btn"
                                  @click="VhOrderBy(4)"
                                >
                                  &uarr; &darr;
                                </button>
                              </span>
                            </th>
                            <th style="text-align: start">
                              Stage<span>
                                <button
                                  class="asc-desc-btn"
                                  @click="VhOrderBy(5)"
                                >
                                  &uarr; &darr;
                                </button>
                              </span>
                            </th>
                            <th style="text-align: start">
                              Step<span>
                                <button
                                  class="asc-desc-btn"
                                  @click="VhOrderBy(6)"
                                >
                                  &uarr; &darr;
                                </button>
                              </span>
                            </th>
                            <th style="text-align: start">
                              Physician<span>
                                <button
                                  class="asc-desc-btn"
                                  @click="VhOrderBy(7)"
                                >
                                  &uarr; &darr;
                                </button>
                              </span>
                            </th>
                            <th style="text-align: start">
                              Comment<span>
                                <button
                                  class="asc-desc-btn"
                                  @click="VhOrderBy(8)"
                                >
                                  &uarr; &darr;
                                </button>
                              </span>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(vhis, ndx04) in visitHistory"
                            :key="ndx04"
                          >
                            <td>{{ vhis.visitTypeName }}</td>
                            <td>{{ vhis.reason }}</td>
                            <td>{{ vhis.dosLocalDateStr }}</td>
                            <td>{{ vhis.dosLocalTimeStr }}</td>
                             <td>
                              <span v-if="vhis.isCheckedOut!==1">
                               {{ vhis.stageName }}
                               </span>
                               <span v-else>
                                Checked Out
                                </span>
                            </td>
                             <td>
                              <span v-if="vhis.isCheckedOut!==1">
                               {{  vhis.stepName  }}
                               </span>
                               <span v-else>
                                Checked Out
                                </span>
                            </td>                           
                            <td>{{ vhis.physicianName }}</td>
                            <td>{{ vhis.commentText }}</td>
                          </tr>
                        </tbody>
                      </table>
                      <nav aria-label="Page navigation" style=" width: 100%;float: right">
                        <!-- usmanbutt -->
                        <span
                          style="padding-left: 40px"
                          v-if="VhtotalRows < VhpageSize * VhpageNumber"
                          >showing {{ VhtotalRows }} of {{ VhtotalRows }} records</span
                        >
                        <span style="padding-left: 40px" v-else
                          >showing {{ VhpageSize * VhpageNumber }} of
                          {{ VhtotalRows }} records</span
                        >
                        <ul class="pagination" style="float: right">
                          <li class="page-item colorActive">
                            <span v-if="VhpageNumber == 1">
                              <button
                                disabled
                                class="page-link disabledColor"
                                @click="VhpageChange('Previous')"
                              >
                                Previous
                              </button>
                            </span>
                            <span v-else>
                              <button class="page-link" @click="VhpageChange('Previous')">
                                Previous
                              </button>
                            </span>
                          </li>
                              <!--show pagination--> 
                          <li v-if="showPagesMin1 > 1">
                            <button class="page-link" @click="VhpageChange(1)">
                                1
                              </button>
                        </li>
                          <li v-if=" showPagesMin1>1 ">
                            <button
                                disabled
                                class="page-link disabledColor"
                              >
                                ...
                              </button>
                          </li>
                            <!--show pagination--> 
                          <li
                            v-for="pageNum in VhtotalPages"
                            :key="pageNum"
                            class="page-item colorActive"
                          >
                          
                            <span v-if="pageNum >= showPagesMin1 && pageNum <= showPagesMax1"> 
                            <span v-if="VhpageNumber == pageNum"
                              ><button
                                class="page-link activeColor"
                                disabled
                                @click="VhpageChange(pageNum)"
                              >
                                {{ pageNum }}
                              </button>
                            </span>
                            <span v-else>
                              <button class="page-link" @click="VhpageChange(pageNum)">
                                {{ pageNum }}
                              </button></span
                            >
                            </span>
                          </li>

                          <!--show pagination-->          
                          <li v-if="VhtotalPages > 10 && (VhtotalPages-4) >= VhpageNumber">
                            <button
                                disabled
                                class="page-link disabledColor"
                              >
                                ...
                              </button>
                          </li>
                        <li v-if="VhtotalPages > 10 &&  (VhtotalPages-4) >= VhpageNumber">
                            <button class="page-link" @click="pageChange(totalPages)">
                                {{ VhtotalPages }}
                              </button>
                        </li>
                          <!--show pagination-->   
                          <li class="page-item colorActive"> 
                            <span v-if="VhpageNumber == VhtotalPages">
                              <button
                                disabled
                                class="page-link disabledColor"
                                @click="pageChange('Next')"
                              >
                                Next
                              </button>
                            </span>
                            <span v-else>
                              <button class="page-link" @click="pageChange('Next')">
                                Next
                              </button>
                        
                            </span>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>

                <!-- Payment Received -->
                <div
                  class="tab-pane profile-tab-pane"
                  id="paymentHistory3"
                  role="tabpanel"
                  style="overflow: hidden"
                >
                  <div style="display:none" class="row justify-content-end">
                    <div class="col-sm-4" style="left: -25px !important">
                      <div class="input-group mb-3">
                        <div class="col-sm-4">
                          <input
                            style="margin-bottom: 6px; margin-left: 51px"
                            type="text"
                            name="daterange"
                            :value="initDate_3"
                            @change="datePicker_3"
                            @focus="datePicker_3"
                          />
                          <div class="input-group-append">
                            <span
                              class="input-group-text"
                              style="
                                position: absolute;
                                margin-top: -34px;
                                margin-left: 230px;
                              "
                            >
                              <span class="ti-calendar"></span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="modal-body" style="width: 933px">
                     <div class="table-responsive">
                      <div
                        class="
                          dataTables_wrapper
                          container-fluid
                          dt-bootstrap4
                          no-footer
                        "
                      >
                        <div class="dataTables_length">
                          <span style="margin-right: 10px"
                            ><label for="">Show </label>
                          </span>
                          <select
                            v-model="VhpageSize"
                            class="form-control form-control-sm"
                            aria-label="Default select example"
                            @change="PhpageChange(1)"
                          >
                            <option selected>50</option>
                            <option value="100">100</option>
                            <option value="500">500</option>
                            <option value="1000">1000</option>
                            <option value="2000">2000</option>
                          </select>

                          <span style="margin-left: 10px">
                            <label for=""> Entries </label></span
                          >
                        </div>
                      </div>
                      <table
                        id="visitm"
                        class="
                          table
                          display
                          table-bordered table-striped
                          no-wrap
                        "
                      >
                        <thead class="thead-dark">
                          <tr>
                            <th style="text-align: start">
                              DOS<span>
                                <button
                                  class="asc-desc-btn"
                                  @click="PhOrderBy(1)"
                                >
                                  &uarr; &darr;
                                </button>
                              </span>
                            </th>
                            <th style="text-align: start">
                              Amount<span>
                                <button
                                  class="asc-desc-btn"
                                  @click="PhOrderBy(2)"
                                >
                                  &uarr; &darr;
                                </button>
                              </span>
                            </th>
                            <th style="text-align: start">
                              Method<span>
                                <button
                                  class="asc-desc-btn"
                                  @click="PhOrderBy(3)"
                                >
                                  &uarr; &darr;
                                </button>
                              </span>
                            </th>
                            <th style="text-align: start">
                              Comment<span>
                                <button
                                  class="asc-desc-btn"
                                  @click="PhOrderBy(4)"
                                >
                                  &uarr; &darr;
                                </button>
                              </span>
                            </th>
                            <th style="text-align: start">
                              Stage<span>
                                <button
                                  class="asc-desc-btn"
                                  @click="PhOrderBy(5)"
                                >
                                  &uarr; &darr;
                                </button>
                              </span>
                            </th>
                            <th style="text-align: start">
                              Collection Date<span>
                                <button
                                  class="asc-desc-btn"
                                  @click="PhOrderBy(6)"
                                >
                                  &uarr; &darr;
                                </button>
                              </span>
                            </th>
                            <th style="text-align: start">
                              Collected By<span>
                                <button
                                  class="asc-desc-btn"
                                  @click="PhOrderBy(7)"
                                >
                                  &uarr; &darr;
                                </button>
                              </span>
                            </th>
                          </tr>
                        </thead>
                          <tbody>
                          <tr
                            v-for="(ph, ndx04) in paymentHistory"
                            :key="ndx04"
                          >
                            <td>{{ ph.dosStr }}</td>
                            <td>{{ ph.amount }}</td>
                            <td>{{ ph.paymentMethodStr }}</td>
                            <td>{{ ph.comment }}</td>
                            <td>{{ ph.statusStr }}</td>
                            <td>{{ ph.paymentDateStr }}</td>
                            <td>{{ ph.collectedByName }}</td>
                          </tr>
                        </tbody>
                      </table>
                      <nav aria-label="Page navigation" style=" width: 100%;float: right">
                        <!-- usmanbutt -->
                        <span
                          style="padding-left: 40px"
                          v-if="PhtotalRows < PhpageSize * PhpageNumber"
                          >showing {{ PhtotalRows }} of {{ PhtotalRows }} records</span
                        >
                        <span style="padding-left: 40px" v-else
                          >showing {{ PhpageSize * PhpageNumber }} of
                          {{ PhtotalRows }} records</span
                        >
                        <ul class="pagination" style="float: right">
                          <li class="page-item colorActive">
                            <span v-if="PhpageNumber == 1">
                              <button
                                disabled
                                class="page-link disabledColor"
                                @click="PhpageChange('Previous')"
                              >
                                Previous
                              </button>
                            </span>
                            <span v-else>
                              <button class="page-link" @click="PhpageChange('Previous')">
                                Previous
                              </button>
                            </span>
                          </li>
                              <!--show pagination--> 
                          <li v-if="showPagesMin1 > 1">
                            <button class="page-link" @click="PhpageChange(1)">
                                1
                              </button>
                        </li>
                          <li v-if=" showPagesMin1>1 ">
                            <button
                                disabled
                                class="page-link disabledColor"
                              >
                                ...
                              </button>
                          </li>
                            <!--show pagination--> 
                          <li
                            v-for="pageNum11 in PhtotalPages"
                            :key="pageNum11"
                            class="page-item colorActive"
                          >
                          
                            <span v-if="pageNum11 >= showPagesMin1 && pageNum11 <= showPagesMax1"> 
                            <span v-if="PhpageNumber == pageNum11"
                              ><button
                                class="page-link activeColor"
                                disabled
                                @click="PhpageChange(pageNum11)"
                              >
                                {{ pageNum11 }}
                              </button>
                            </span>
                            <span v-else>
                              <button class="page-link" @click="PhpageChange(pageNum11)">
                                {{ pageNum11 }}
                              </button></span
                            >
                            </span>
                          </li>

                          <!--show pagination-->          
                          <li v-if="PhtotalPages > 10 && (PhtotalPages-4) >= VhpageNumber">
                            <button
                                disabled
                                class="page-link disabledColor"
                              >
                                ...
                              </button>
                          </li>
                        <li v-if="PhtotalPages > 10 &&  (PhtotalPages-4) >= VhpageNumber">
                            <button class="page-link" @click="PhpageChange(PhtotalPages)">
                                {{ PhtotalPages }}
                              </button>
                        </li>
                          <!--show pagination-->   
                          <li class="page-item colorActive"> 
                            <span v-if="PhpageNumber == PhtotalPages">
                              <button
                                disabled
                                class="page-link disabledColor"
                                @click="PhpageChange('Next')"
                              >
                                Next
                              </button>
                            </span>
                            <span v-else>
                              <button class="page-link" @click="PhpageChange('Next')">
                                Next
                              </button>
                        
                            </span>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
                <div
                  class="tab-pane profile-tab-paneV2"
                  id="emailHistory"
                  role="tabpanel"
                >
                  <div class="tab-content">
                    <div
                      class="tab-pane active"
                      id="inBoxv3"
                      role="tabpanel"
                      style="width: 1100px !important"
                    >
                      <form class="">
                        <div class="col-10 bg-light">
                          <a
                            href=""
                            data-toggle="modal"
                            data-target="#sendEmail"
                            class="
                              btn btn-danger
                              m-b-20
                              p-10
                              btn-block
                              waves-effect waves-light
                            "
                            @click="sendEmailClick()"
                            >Compose</a
                          >
                          <div class="card-body p-t-0">
                            <div class="card b-all shadow-none">
                              <div class="inbox-center table-responsive">
                                <table class="table table-hover no-wrap">
                                  <tbody>
                                    <tr
                                      v-for="(emailHis, ndx01) in emailHistory"
                                      :key="ndx01"
                                      class=""
                                    >
                                      <td>{{ ndx01 + 1 }})</td>
                                      <td style="width: 40px">
                                        <div
                                          class="
                                            custom-control custom-checkbox
                                            mr-sm-2
                                          "
                                        >
                                          <input
                                            type="checkbox"
                                            class="custom-control-input"
                                            id="checkbox0"
                                            value="check"
                                          />
                                          <!-- <label
                                            class="custom-control-label"
                                            for="checkbox0"
                                          ></label> -->
                                        </div>
                                      </td>
                                      <td
                                        style="width: 40px"
                                        class="hidden-xs-down"
                                      >
                                        <!-- <i class="far fa-star"></i> -->
                                      </td>
                                      <td class="hidden-xs-down">
                                        {{ emailHisUser }}
                                      </td>
                                      <td class="max-texts">
                                        <a
                                          href="javascript:void(0)"
                                          @click="
                                            getEmailInfor(
                                              emailHis.message,
                                              emailHis.emailTo,
                                              emailHis.subject
                                            )
                                          "
                                          class="nav-link"
                                          >{{ emailHis.subject }}</a
                                        >
                                      </td>
                                      <!-- <td class="hidden-xs-down">
                                        <a
                                          @click="getEmailInfor(emailHis.messageShort
                                          , emailHis.message, emailHis.emailTo, emailHis.subject)"
                                          >
                                        <i
                                        class="fa fa-paperclip"></i>
                                        </a>
                                      </td> -->
                                      <td class="text-right">
                                        {{ emailHis.emailDateStr }}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                <div
                  class="tab-pane profile-tab-pane"
                  id="textHistory3"
                  role="tabpanel"
                >
                  <div class="row">
                    <div class="col-10">
                      <div class="card m-b-0">
                        <!-- .chat-row -->
                        <div
                          class="chat-main-box"
                          style="width: 920px !important"
                        >
                          <!-- .chat-left-panel -->
                          <div class="chat-left-aside">
                            <a
                              href=""
                              data-toggle="modal"
                              data-target="#sendText"
                              class="
                                btn btn-info
                                m-b-20
                                p-10
                                btn-block
                                waves-effect waves-light
                              "
                              @click="sendTextClick()"
                              >Compose</a
                            >
                            <div class="open-panel">
                              <i class="ti-angle-right"></i>
                            </div>
                            <div class="chat-left-inner">
                              <div class="form-material">
                                <input
                                  class="form-control p-2"
                                  v-model="TextSearch"
                                  type="text"
                                  placeholder="Search Contact"
                                />
                              </div>
                              <div
                                class="list-group text-left"
                                id="list-tab"
                                role="tablist"
                              >
                                <a
                                  v-for="(user, ndx00B) in filterTextSearch"
                                  :key="ndx00B"
                                  @click="smsContactClick(user)"
                                  role="tab"
                                  aria-selected="true"
                                  ><i></i>{{ user.name }}</a
                                >
                              </div>
                            </div>
                          </div>

                          <!-- .chat-right-panel -->
                          <div class="chat-right-aside">
                            <div class="chat-main-header">
                              <div class="p-3 b-b">
                                <h4 class="box-title">Chat Message</h4>
                              </div>
                            </div>
                            <div class="chat-rbox">
                              <ul class="chat-list p-3">
                                <!--chat Row -->
                                <li
                                  v-for="(sh, ndx00B1) in textHistory"
                                  :key="ndx00B1"
                                >
                                  <div class="chat-content">
                                    <h5 class="font-weight-bolder">
                                      {{ sh.fromName }}
                                    </h5>
                                    <div id="chat" class="chat-time">
                                      {{
                                        sh.messageDate1 + " " + sh.messageTime1
                                      }}
                                    </div>
                                    <div
                                      style="width:610px;"
                                      class="box bg-light-info"
                                    >
                                      {{ sh.message }}
                                    </div>
                                  </div>
                                </li>
                              </ul>
                            </div>
                            <div class="card-body border-top">
                              <div class="row">
                                <div class="col-8">
                                  <textarea
                                    v-model="chatSms"
                                    placeholder="Type your message here"
                                    class="form-control border-0"
                                    maxlength="120"
                                  ></textarea>
                                </div>
                                <div class="col-4 text-right">
                                  <button
                                    type="button"
                                    @click="chatSmsSent()"
                                    class="btn btn-info btn-circle btn-lg"
                                  >
                                    <i class="fas fa-paper-plane"></i>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- .chat-right-panel -->
                        </div>
                        <!-- /.chat-row -->
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="tab-pane profile-tab-pane"
                  id="auditList3"
                  role="tabpanel"
                >
                  <div class="row" v-for="(act, ndx) in auditData" :key="ndx">
                    <div
                      class="col-12"
                      v-for="(dt, ndx01) in act.actionDates"
                      :key="ndx01"
                    >
                      <div class="card">
                        <div class="card-body">
                          <ul class="timeline">
                            <li
                              v-for="(actType, ndx02) in dt.actionTypes"
                              :key="ndx02"
                              :class="ndx01 % 2 == 0 ? '' : 'timeline-inverted'"
                            >
                              <div class="timeline-badge warning">
                                <img
                                  :src="getIcon(actType.actionTypeId)"
                                  alt=""
                                  style="height: 20px; margin: 16px"
                                />
                              </div>
                              <div class="timeline-panel">
                                <div class="row">
                                  <div class="col-8">
                                    <div class="timeline-heading">
                                      <p
                                        class="timeline-title"
                                        style="
                                          font-size: 20px;
                                          font-weight: 800;
                                        "
                                      >
                                        {{ actType.actionTypeName }}
                                        <br /><small class="text-muted">{{
                                          actType.appModelName
                                        }}</small>
                                      </p>
                                    </div>
                                  </div>
                                  <div class="col-4">
                                    <h4 class="timeline-title">
                                      {{ act.actionToName }}
                                    </h4>
                                    <p>
                                      <small class="text-muted">
                                        <i class="fa fa-clock-o"></i
                                        >{{ dateToLocalString(dt.actionDate) }}
                                      </small>
                                    </p>
                                  </div>
                                </div>
                                <div class="timeline-body">
                                  <p
                                    v-for="(msg,
                                    ndx03) in actType.actionMessages"
                                    :key="ndx03"
                                  >
                                    {{ msg }}
                                  </p>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- $$**$$ End -->
    <!-- New Patients Modal -->

<Dialog
      v-model:visible="displayPayMethod"
      style="width: 30%; max-height: 100%"
      @hide="closeModalRem()"
      position="top"
      :modal="true"
    >
      <template #header>
        <h4 class="modal-title" id="myModalLabel">Select A Payment Method</h4>
      </template>
      <form>
        <div class="row text-center">
          <div class="col m-2 p-2">
            <a href="javascript:void(0)" @click="showSubmitPaymentModal(1)">
              <i class="far fa-credit-card fa-5x mb-3 blue-text"></i>
              <h4 class="font-weight-bold">Credit Or Debit Card</h4>
            </a>
          </div>

          <div class="col m-2 p-2">
            <a href="javascript:void(0)" @click="showSubmitPaymentModal(2)">
              <i class="fas fa-hand-holding-usd fa-5x mb-3 blue-text"></i>
              <h4 class="font-weight-bold">Cash</h4>
            </a>
          </div>

          <div class="col m-2 p-2">
            <a href="javascript:void(0)" @click="showSubmitPaymentModal(3)">
              <i class="fas fa-money-check-alt fa-5x mb-3 blue-text"></i>
              <h4 class="font-weight-bold">Cheque</h4>
            </a>
          </div>
        </div>
      </form>
    </Dialog>

 <!-- Payment Authorize Credit -->
    <div
      id="debit"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Payment Via Authorize</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>
          </div>
          <div class="modal-body">
            <h4 class="font-weight-bold h4-responsive">
              Payment Verfication will be Done
            </h4>
            <form class="floating-labels m-t-40">
              <div
                class="form-group m-b-40"
                :class="[
                  aSinglePaymentReceived.holderName != null ? '' : 'focused',
                ]"
              >
                <span class="p-float-label">
                  <InputText
                    type="text"
                    class="form-control float-class"
                    id=""
                    maxlength="30"
                    v-model="aSinglePaymentReceived.holderName"
                  /><span class="bar"></span>
                  <label for="" id="font1"
                    >Card Holder Name<span style="color: red"> *</span></label
                  >
                </span>
              </div>
              <div
                class="form-group m-b-40"
                :class="[
                  aSinglePaymentReceived.tdNumber != null ? '' : 'focused',
                ]"
              >
                <span class="p-float-label">
                  <InputText
                    v-mask="'####-####-####-####'"
                    type="tel"
                    class="form-control float-class"
                    id=""
                    v-model="aSinglePaymentReceived.tdNumber"
                  /><span class="bar"></span>
                  <label for="" id="font1"
                    >Card Number<span style="color: red"> *</span></label
                  >
                </span>
              </div>
              <div
                class="form-group m-b-40"
                :class="[
                  aSinglePaymentReceived.cardCVC != null ? '' : 'focused',
                ]"
              >
                <span class="p-float-label">
                  <InputText
                    v-mask="'######'"
                    type="tel"
                    class="form-control float-class"
                    id=""
                    v-model="aSinglePaymentReceived.cardCVC"
                  /><span class="bar"></span>
                  <label for="" id="font1"
                    >Card CVC<span style="color: red"> *</span></label
                  >
                </span>
              </div>
              <div
                class="form-group m-b-40"
                :class="[aSinglePaymentReceived.zip != null ? '' : 'focused']"
              >
                <span class="p-float-label">
                  <InputText
                    type="text"
                    class="form-control float-class"
                    id=""
                    maxlength="8"
                    v-model="aSinglePaymentReceived.zip"
                  /><span class="bar"></span>
                  <label for="" id="font1"
                    >Zip<span style="color: red"> *</span></label
                  >
                </span>
              </div>
              <div
                class="form-group m-b-40"
                :class="[aSinglePaymentReceived.amount != null ? '' : 'focused']"
              >
                <span class="p-float-label">
                  <InputText
                    type="number"
                    class="form-control float-class"
                    min="0"
                    id=""
                    disabled
                    @keypress="isNumber($event)"
                    v-model="aSinglePaymentReceived.amount"
                  /><span class="bar"></span>
                  <label for="" id="font1"
                    >Amount<span style="color: red"> *</span></label
                  >
                </span>
              </div>
              <div
                class="form-group"
                :class="[
                  aSinglePaymentReceived.comment != null ? '' : 'focused',
                ]"
              >
                <span class="p-float-label">
                  <InputText
                    class="form-control float-class"
                    id=""
                    maxlength="255"
                    v-model="aSinglePaymentReceived.comment"
                  /><span class="bar"></span>
                  <label for="" id="font1"
                    >Comment<span style="color: red"> *</span>:</label
                  >
                </span>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-success waves-effect waves-light col-12"
              id="creditCardPayment"
              @click="paymentReceivedClick('credit-card')"
            >
              Process
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Payment Authorize Credit  -->
    
   <div
      id="cash"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Cash On The Spot</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>
          </div>
          <div class="modal-body">
            <form class="floating-labels m-t-40">
              <div
                class="form-group m-b-40"
                v-bind:class="[
                  aSinglePaymentReceived.amount != null ? 'focused' : '',
                ]"
              >
                <input
                  type="number"
                  class="form-control"
                  id=""
                  min="0"
                  disabled
                  @keypress="isNumber($event)"
                  v-model="aSinglePaymentReceived.amount"
                /><span class="bar"></span>
                <label for=""
                  >Amount(In $)<span style="color: red"> *</span></label
                >
              </div>
              <div
                class="form-group"
                :class="[
                  aSinglePaymentReceived.comment != null ? '' : 'focused',
                ]"
              >
                <span class="p-float-label">
                  <InputText
                    class="form-control float-class"
                    id=""
                    maxlength="255"
                    v-model="aSinglePaymentReceived.comment"
                  /><span class="bar"></span>
                  <label for="" id="font1"
                    >Comment<span style="color: red"> *</span>:</label
                  >
                </span>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-success waves-effect waves-light col-12"
              id="cashPayment"
              @click="paymentReceivedClick('cash')"
            >
              Collect
            </button>
          </div>
        </div>
      </div>
    </div>

     <!-- Payment Authorize cheque -->
    <div
      id="cheque"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Payment Via Cheque</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>
          </div>
          <div class="modal-body">
            <form class="floating-labels m-t-40">
              <div
                class="form-group m-b-40"
                v-bind:class="[
                  aSinglePaymentReceived.tdNumber != null ? '' : 'focused',
                ]"
              >
                <span class="p-float-label">
                  <InputText
                    v-mask="'####-####-####-####'"
                    type="tel"
                    class="form-control float-class"
                    id=""
                    v-model="aSinglePaymentReceived.tdNumber"
                  /><span class="bar"></span>
                  <label for="" id="font1"
                    >Cheque Number<span style="color: red"> *</span></label
                  >
                </span>
              </div>
              <div
                class="form-group m-b-40"
                v-bind:class="[
                  aSinglePaymentReceived.amount != null ? 'focused' : '',
                ]"
              >
                <input
                  type="number"
                  class="form-control"
                  id=""
                  min="0"
                  disabled
                  @keypress="isNumber($event)"
                  v-model="aSinglePaymentReceived.amount"
                /><span class="bar"></span>
                <label for=""
                  >Amount(In $)<span style="color: red"> *</span></label
                >
              </div>
              <div
                class="form-group m-b-40"
                v-bind:class="[
                  aSinglePaymentReceived.holderName != null ? '' : 'focused',
                ]"
              >
                <span class="p-float-label">
                  <InputText
                    type="text"
                    class="form-control float-class"
                    id=""
                    maxlength="100"
                    v-model="aSinglePaymentReceived.holderName"
                  /><span class="bar"></span>
                  <label for="" id="font1"
                    >Cheque Holder Name<span style="color: red"> *</span></label
                  >
                </span>
              </div>
              <div
                class="form-group"
                :class="[
                  aSinglePaymentReceived.comment != null ? '' : 'focused',
                ]"
              >
                <span class="p-float-label">
                  <InputText
                    class="form-control float-class"
                    id=""
                    maxlength="255"
                    v-model="aSinglePaymentReceived.comment"
                  /><span class="bar"></span>
                  <label for="" id="font1"
                    >Comment<span style="color: red"> *</span>:</label
                  >
                </span>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-success waves-effect waves-light col-12"
              id="chequePayment"
              @click="paymentReceivedClick('cheque')"
            >
              Collect
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- payment method modal -->

    <!-- Payment Request Modal -->
    <div
      id="paymentRequest"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Payment Request</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>
          </div>
          <div class="modal-body">
            <form class="floating-labels m-t-40">
              <div class="form-group m-b-40"
               v-bind:class="[
                  aSingleRequestPayment.amount.length >= 0 ? 'focused' : 'focused',
                ]">
                <input
                  type="number"
                  class="form-control"
                  id="amount"
                  @keypress="isNumber($event)"
                  v-model="aSingleRequestPayment.amount"
                /><span class="bar"></span>
                <label for="amount">Amount(In $)<span  style="color:red"> *</span></label>
              </div>
              <div
                class="form-group m-b-40"
                v-bind:class="[
                  aSingleRequestPayment.email.length > 0 ? 'focused' : '',
                ]"
              >
                <input
                  type="email"
                  class="form-control"
                  id=""
                  v-model="aSingleRequestPayment.email"
                /><span class="bar"></span>
                <label for="email">Email<span  style="color:red"> *</span></label>
              </div>
              <div
                class="form-group m-b-40"
                :class="[
                  aSingleRequestPayment.phone.length > 0 ? 'focused' : '',
                ]"
              >
                <input
                  v-mask="'###-###-####'"
                  type="tel"
                  class="form-control"
                  id="phonenumber"
                  v-model="aSingleRequestPayment.phone"
                /><span class="bar"></span>
                <label for="phonenumber">Phone Number<span  style="color:red"> *</span></label>
              </div>
              <div
                class="form-group m-b-40"
                v-bind:class="[
                  aSingleRequestPayment.comment.length > 0 ? 'focused' : '',
                ]"
              >
                <label for="comment-text" class="control-label">Comment<span  style="color:red"> *</span>:</label>
                <textarea
                  class="form-control"
                  id="comment-text"
                  v-model="aSingleRequestPayment.comment"
                ></textarea>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-success waves-effect waves-light col-12"
              id="requestPayment"
              @click="savePaymentRequest"
            >
              Send Payment Request
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Payment Request Modal -->

<!-- Reminder -->
    <div
      id="reminder"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Reminder</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>
          </div>
          <div class="modal-body">
            <form class="floating-labels m-t-40">
              <div class="form-group m-b-40">
                <input
                  type="text"
                  v-model="Reminder.email"
                  class="form-control"
                  id=""
                /><span class="bar"></span>
                <label for="">Email<span style="color: red"> *</span></label>
              </div>
              <div class="form-group m-b-40">
                <input
                  v-mask="'###-###-####'"
                  type="tel"
                  v-model="Reminder.phone"
                  class="form-control"
                  id=""
                /><span class="bar"></span>
                <label for=""
                  >Phone Number<span style="color: red"> *</span></label
                >
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              @click="sendReminderClick"
              class="btn btn-success waves-effect waves-light"
            >
              Send
            </button>
            <button
              type="button"
              class="btn btn-danger waves-effect waves-light"
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Reminder -->

    <!-- Assign Physician -->
    <div
      class="modal fade bs-example-modal-lg"
      id="assignPhysician"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myLargeModalLabel"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" id="myLargeModalLabel">Assign Physician</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>
          </div>

          <div class="modal-body mb-1 pt-2">
            <div class="table-responsive">
              <table
                id="config-table3"
                class="table display table-bordered table-striped no-wrap"
              >
                <thead class="thead-dark">
                  <tr>
                    <th>Action</th>
                    <th>Name</th>
                    <th>DOB</th>
                    <th>Email</th>
                    <th>Phone</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(phy, ndxA01) in phyList" :key="ndxA01">
                   <td>
                      <button
                        v-if="phy.isPhysicianActive == true"
                        class="btn btn-info unassignPhyStage"
                      >
                        Assigned
                      </button>
                      <button
                        v-else
                        @click="phyAssignedClick(phy)"
                        class="btn btn-dark assignPhyStage"
                      >
                        Assign Physician
                      </button>
                    </td>
                    <td>{{ phy.name }}</td>
                    <td>{{ phy.dob }}</td>
                    <td>
                      <!-- <span
                        class="__cf_email__"
                        data-cfemail="7c043c1b111d1510521f1311"
                        >[email&#160;protected]</span
                      > -->
                      {{ phy.email }}
                    </td>
                    <td>{{ phy.phone }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- Assign Physician -->

      <!-- **MergeModal -->
      <div
        id="mergeModal"
        class="modal fade"
        tabindex="-1"
        role="dialog"
        aria-labelledby="myModalLabel"
        aria-hidden="true"
        style="display: none"
      >
        <div class="modal-dialog cascading-modal modal-lg" role="document">
          <!-- Content -->
          <div
            class="modal-content"
            style="width: 1200px; display: block; margin-left: -138px"
          >
            <!--Modal cascading tabs-->
            <div class="modal-c-tabs">
              <!-- Nav tabs -->
              <ul class="nav md-tabs tabs-2 light-blue darken-3" role="tablist">
                <li class="nav-item" @click="mergeModalClickReloadChange()">
                  <a
                    id="mappingClick"
                    class="btn btn-outline-custom m-2 nav-link white-text show active"
                    data-toggle="tab"
                    href="#veinsPanel"
                    role="tab"
                    aria-selected="false"
                    ><i class="fas fa-user-plus mr-1"></i> Suggested</a
                  >
                </li>
                <li class="nav-item" @click="mergeModalClickReload1()">
                  <a
                    class="btn btn-outline-custom m-2 nav-link white-text"
                    data-toggle="tab"
                    href="#myPatientPanel"
                    role="tab"
                    style="color: #fb9678 ;border-color: #fb9678; "
                    aria-selected="true"
                    ><i class="fas fa-user mr-1"></i> All Patients</a
                  >
                </li>
              </ul>
              <!-- Tab panels -->
              <div class="tab-content">
                <!-- === Merge Patient Panel ALL ==== -->
                <div class="tab-pane fade" id="myPatientPanel" role="tabpanel">
                  <!-- Body -->
                  <div class="modal-body mb-1 pt-2">
                    <div class="table-responsive">
                      <table
                        class="table display table-bordered table-striped no-wrap"
                      >
                        <thead class="thead-dark">
                          <tr>
                            <th>PT ID</th>
                            <th>External Id</th>
                            <th>First Name</th>
                            <th>Last Name</th>
                            <th>DOB</th>
                            <th>Email</th>
                            <th>Phone</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              <button
                                class="
                                  btn btn-facebook btn-sm
                                  waves-effect waves-light
                                "
                                type="button"
                              >
                                {{ aSinglePatient.ptid }}
                              </button>
                            </td>
                            <td>{{ aSinglePatient.externalId }}</td>
                            <td>{{ aSinglePatient.firstName }}</td>
                            <td>{{ aSinglePatient.lastName }}</td>
                            <td>{{ aSinglePatient.dob }}</td>
                            <td>
                              {{ aSinglePatient.email }}
                              <!-- <span
                                class="__cf_email__"
                                data-cfemail="b3cbf3d4ded2dadf9dd0dcde"
                                >[email&#160;protected]</span
                              > -->
                            </td>
                            <td>{{ aSinglePatient.phone }}</td>
                          </tr>
                        </tbody>
                      </table>
  
                      <!-- class="btn btn-outline-info col-12" -->
                      <div class="container">
                        <div class="row mt-3 mb-3">
                          <button
                            type="button"
                            class="btn btn-outline-info col-12"
                            @click="newPatientClick"
                            :disabled="aSinglePatient.patientId > 0"
                          >
                            This is a New Patient
                          </button>
                        </div>
                      </div>
  
                      <hr class="solid text-black-50" />
  
                      <div class="row">
                        <div class="col-1">
                          <div class="form-group">
                            <span class="p-float-label">
                              <InputText
                                type="text"
                                id=""
                                placeholder=""
                                v-model="suggested1.searchVeinsId"
                                @change="applyDateClickSuggested1()"
                                style="width: 100%"
                              />
                              <label id="font1">PT ID</label>
                            </span>
                          </div>
                        </div>
                        <div class="col-2">
                          <div class="form-group">
                            <span class="p-float-label">
                              <InputText
                                type="text"
                                id=""
                                placeholder=""
                                v-model="suggested1.searchExternalId"
                                @change="applyDateClickSuggested1()"
                                style="width: 100%"
                              />
                              <label id="font1">External ID</label>
                            </span>
                          </div>
                        </div>
  
                        <div class="col-2">
                          <div class="form-group">
                            <span class="p-float-label">
                              <InputText
                                type="text"
                                id=""
                                placeholder=""
                                maxlength="50"
                                v-model="suggested1.searchFirstName"
                                @change="applyDateClickSuggested1()"
                                style="width: 100%"
                              />
                              <label id="font1">First Name</label>
                            </span>
                          </div>
                        </div>
                        <div class="col-2">
                          <div class="form-group">
                            <span class="p-float-label">
                              <InputText
                                type="text"
                                id=""
                                placeholder=""
                                maxlength="50"
                                v-model="suggested1.searchLastName"
                                @change="applyDateClickSuggested1()"
                                style="width: 100%"
                              />
                              <label id="font1">Last Name</label>
                            </span>
                          </div>
                        </div>
                        <div class="col-2">
                          <div class="form-group">
                            <span class="p-float-label">
                              <InputText
                                v-mask="'###-###-####'"
                                type="tel"
                                id=""
                                placeholder=""
                                v-model="suggested1.searchPhone"
                                @change="applyDateClickSuggested1()"
                                style="width: 100%"
                              />
                              <label id="font1">Phone</label>
                            </span>
                          </div>
                        </div>
                        <div class="col-3">
                          <div class="form-group">
                            <span class="p-float-label">
                              <InputText
                                type="date"
                                id=""
                                placeholder=""
                                v-model="suggested1.Dob"
                                @change="applyDateClickSuggested1()"
                                style="width: 100%"
                              />
                            </span>
                          </div>
                        </div>
                      </div>
  
                      <div class="table-responsive">
                        <div
                          class="
                            dataTables_wrapper
                            container-fluid
                            dt-bootstrap4
                            no-footer
                          "
                        >
                          <div class="dataTables_length">
                            <span style="margin-right: 10px"
                              ><label for="">Show </label>
                            </span>
                            <select
                              v-model="pageSize"
                              class="form-control form-control-sm"
                              aria-label="Default select example"
                              @change="pageChangeSuggested1(1)"
                            >
                              <option selected>50</option>
                              <option value="100">100</option>
                              <option value="500">500</option>
                              <!-- <option value="1000">1000</option>
                              <option value="2000">2000</option> -->
                            </select>
  
                            <span style="margin-left: 10px">
                              <label for=""> Entries </label></span
                            >
                          </div>
                        </div>
                        <table
                          class="
                            table
                            display
                            table-bordered
                            text-center
                            table-striped
                            no-wrap
                          "
                          id="home_22"
                        >
                          <thead class="thead-dark">
                            <tr>
                              <th style="text-align: start">
                                PT ID<span>
                                  <button
                                    class="asc-desc-btn"
                                    @click="orderBySuggested1(1)"
                                  >
                                    &uarr; &darr;
                                  </button>
                                </span>
                              </th>
                              <th style="text-align: start">
                                External Id<span>
                                  <button
                                    class="asc-desc-btn"
                                    @click="orderBySuggested1(2)"
                                  >
                                    &uarr; &darr;
                                  </button>
                                </span>
                              </th>
                              <th style="text-align: start">
                                First Name<span>
                                  <button
                                    class="asc-desc-btn"
                                    @click="orderBySuggested1(3)"
                                  >
                                    &uarr; &darr;
                                  </button>
                                </span>
                              </th>
                              <th style="text-align: start">
                                Last Name<span>
                                  <button
                                    class="asc-desc-btn"
                                    @click="orderBySuggested1(4)"
                                  >
                                    &uarr; &darr;
                                  </button>
                                </span>
                              </th>
                              <th style="text-align: start">
                                DOB<span>
                                  <button
                                    class="asc-desc-btn"
                                    @click="orderBySuggested1(5)"
                                  >
                                    &uarr; &darr;
                                  </button>
                                </span>
                              </th>
                              <th style="text-align: start">
                                Email<span>
                                  <button
                                    class="asc-desc-btn"
                                    @click="orderBySuggested1(6)"
                                  >
                                    &uarr; &darr;
                                  </button>
                                </span>
                              </th>
                              <th style="text-align: start">
                                Phone<span>
                                  <button
                                    class="asc-desc-btn"
                                    @click="orderBySuggested1(7)"
                                  >
                                    &uarr; &darr;
                                  </button>
                                </span>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-if="suggestedPatients1.length == 0">
                              <td align="center" colspan="100">
                                <strong> No data available</strong>
                              </td>
                            </tr>
                            <tr
                              v-for="(pat1, ndx041) in suggestedPatients1"
                              :key="ndx041"
                            >
                              <td>
                                <button
                                  class="
                                    btn btn-facebook btn-sm
                                    waves-effect waves-light
                                  "
                                  type="button"
                                  @click="checkPatient(pat1)"
                                >
                                  {{ pat1.ptid }}
                                </button>
                              </td>
                              <td>{{ pat1.externalId }}</td>
                              <td>{{ pat1.firstName }}</td>
                              <td>{{ pat1.lastName }}</td>
                              <td>{{ pat1.dob }}</td>
                              <td>
                                {{ pat1.email }}
                              </td>
                              <td>{{ pat1.phone }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <nav aria-label="Page navigation">
                        <span
                          style="padding-left: 40px"
                          v-if="
                            totalRowsSuggest1 <
                              pageSizeSuggest1 * pageNumberSuggest1
                          "
                          >showing {{ totalRowsSuggest1 }} of
                          {{ totalRowsSuggest1 }} records</span
                        >
                        <span style="padding-left: 40px" v-else
                          >showing {{ pageSizeSuggest1 * pageNumberSuggest1 }} of
                          {{ totalRowsSuggest1 }} records</span
                        >
                        <ul class="pagination" style="float: right">
                          <li class="page-item colorActive">
                            <span v-if="pageNumberSuggest1 == 1">
                              <button
                                disabled
                                class="page-link disabledColor"
                                @click="pageChangeSuggested1('Previous')"
                              >
                                Previous
                              </button>
                            </span>
                            <span v-else>
                              <button
                                class="page-link"
                                @click="pageChangeSuggested1('Previous')"
                              >
                                Previous
                              </button>
                            </span>
                          </li>
                          <!--show pagination-->
                          <li v-if="showPagesMin1 > 1">
                            <button
                              class="page-link"
                              @click="pageChangeSuggested1(1)"
                            >
                              1
                            </button>
                          </li>
                          <li v-if="showPagesMin1 > 1">
                            <button disabled class="page-link disabledColor">
                              ...
                            </button>
                          </li>
                          <!--show pagination-->
                          <li
                            v-for="pageNumSugg1 in totalPagesSuggest1"
                            :key="pageNumSugg1"
                            class="page-item colorActive"
                          >
                            <span
                              v-if="
                                pageNumSugg1 >= showPagesMin1 &&
                                  pageNumSugg1 <= showPagesMax1
                              "
                            >
                              <span v-if="pageNumberSuggest1 == pageNumSugg1"
                                ><button
                                  class="page-link activeColor"
                                  disabled
                                  @click="pageChangeSuggested1(pageNumSugg1)"
                                >
                                  {{ pageNumSugg1 }}
                                </button>
                              </span>
                              <span v-else>
                                <button
                                  class="page-link"
                                  @click="pageChangeSuggested1(pageNumSugg1)"
                                >
                                  {{ pageNumSugg1 }}
                                </button>
                              </span>
                            </span>
                          </li>
                          <!--show pagination-->
                          <li
                            v-if="
                              totalPagesSuggest1 > 10 &&
                                totalPagesSuggest1 - 4 >= pageNumber
                            "
                          >
                            <button disabled class="page-link disabledColor">
                              ...
                            </button>
                          </li>
                          <li
                            v-if="
                              totalPagesSuggest1 > 10 &&
                                totalPagesSuggest1 - 4 >= pageNumberSuggest1
                            "
                          >
                            <button
                              class="page-link"
                              @click="pageChangeSuggested1(totalPagesSuggest1)"
                            >
                              {{ totalPagesSuggest1 }}
                            </button>
                          </li>
                          <!--show pagination-->
                          <li class="page-item colorActive">
                            <span v-if="pageNumberSuggest1 == totalPagesSuggest1">
                              <button
                                disabled
                                class="page-link disabledColor"
                                @click="pageChangeSuggested1('Next')"
                              >
                                Next
                              </button>
                            </span>
                            <span v-else>
                              <button
                                class="page-link"
                                @click="pageChangeSuggested1('Next')"
                              >
                                Next
                              </button>
                            </span>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
  
                  <!-- Footer -->
                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-outline-info waves-effect ml-auto"
                      data-dismiss="modal"
                    >
                      Close
                    </button>
                  </div>
                  <!-- Footer -->
                </div>
                <!-- === Merge Patient Panel ==== -->
  
                <!-- === Veins Patient - Suggested === -->
                <div
                  class="tab-pane fade in active show"
                  id="veinsPanel"
                  role="tabpanel"
                >
                  <!-- Body -->
                  <div class="modal-body mb-1 pt-2">
                    <div class="table-responsive">
                      <table
                        class="table display table-bordered table-striped no-wrap"
                      >
                        <thead class="thead-dark">
                          <tr>
                            <th>PT ID</th>
                            <th>External Id</th>
                            <th>First Name</th>
                            <th>Last Name</th>
                            <th>DOB</th>
                            <th>Email</th>
                            <th>Phone</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              <button
                                class="
                                  btn btn-facebook btn-sm
                                  waves-effect waves-light
                                "
                                type="button"
                              >
                                {{ aSinglePatient.ptid }}
                              </button>
                            </td>
                            <td>{{ aSinglePatient.externalId }}</td>
                            <td>{{ aSinglePatient.firstName }}</td>
                            <td>{{ aSinglePatient.lastName }}</td>
                            <td>{{ aSinglePatient.dob }}</td>
                            <td>
                              {{ aSinglePatient.email }}
                              <!-- <span
                                class="__cf_email__"
                                data-cfemail="b3cbf3d4ded2dadf9dd0dcde"
                                >[email&#160;protected]</span
                              > -->
                            </td>
                            <td>{{ aSinglePatient.phone }}</td>
                          </tr>
                        </tbody>
                      </table>
  
                      <div v-if="updButton == 1" class="container">
                        <div class="row mt-3 mb-3">
                          <button
                            type="button"
                            :class="
                              aSinglePatient.patientId > 0
                                ? 'btn btn-outline-secondary waves-effect col-12'
                                : 'btn btn-outline-info waves-effect col-12'
                            "
                            :disabled="aSinglePatient.patientId > 0"
                            @click="newPatientClick"
                          >
                            This is a New Patient
                          </button>
                        </div>
                      </div>
  
                      <div v-else class="container">
                        <div class="row mt-3 mb-3">
                          <button
                            type="button"
                            :class="
                              aSinglePatient.patientId > 0
                                ? 'btn btn-outline-secondary waves-effect col-12'
                                : 'btn btn-outline-info waves-effect col-12'
                            "
                            :disabled="updButton == 0"
                            @click="newPatientClick"
                          >
                            This is a New Patient
                          </button>
                        </div>
                      </div>
  
                      <!-- <div v-if="suggestedPatients.length > 0"> -->
                      <hr class="solid text-black-50" />
  
                      <div class="row">
                        <div class="col-12">
                          <form class="floating-labels">
                            <legend class="text-center" style="font-weight: 900">
                              These are some suggested profiles we found...
                            </legend>
                          </form>
                        </div>
                      </div>
  
                      <div v-show="displaySearch" class="row">
                        <div class="col-1">
                          <div class="form-group">
                            <span class="p-float-label">
                              <InputText
                                type="text"
                                id=""
                                placeholder=""
                                v-model="suggested.searchVeinsId"
                                @change="applyDateClickSuggested()"
                                style="width: 100%"
                              />
                              <label id="font1">PT ID</label>
                            </span>
                          </div>
                        </div>
                        <div class="col-2">
                          <div class="form-group">
                            <span class="p-float-label">
                              <InputText
                                type="text"
                                id=""
                                placeholder=""
                                v-model="suggested.searchExternalId"
                                @change="applyDateClickSuggested()"
                                style="width: 100%"
                              />
                              <label id="font1">External ID</label>
                            </span>
                          </div>
                        </div>
  
                        <div class="col-2">
                          <div class="form-group">
                            <span class="p-float-label">
                              <InputText
                                type="text"
                                id=""
                                placeholder=""
                                maxlength="50"
                                v-model="suggested.searchFirstName"
                                @change="applyDateClickSuggested()"
                                style="width: 100%"
                              />
                              <label id="font1">First Name</label>
                            </span>
                          </div>
                        </div>
                        <div class="col-2">
                          <div class="form-group">
                            <span class="p-float-label">
                              <InputText
                                type="text"
                                id=""
                                placeholder=""
                                maxlength="50"
                                v-model="suggested.searchLastName"
                                @change="applyDateClickSuggested()"
                                style="width: 100%"
                              />
                              <label id="font1">Last Name</label>
                            </span>
                          </div>
                        </div>
                        <div class="col-2">
                          <div class="form-group">
                            <span class="p-float-label">
                              <InputText
                                v-mask="'###-###-####'"
                                type="tel"
                                id=""
                                placeholder=""
                                v-model="suggested.searchPhone"
                                @change="applyDateClickSuggested()"
                                style="width: 100%"
                              />
                              <label id="font1">Phone</label>
                            </span>
                          </div>
                        </div>
                        <div class="col-3">
                          <div class="form-group">
                            <span class="p-float-label">
                              <InputText
                                type="date"
                                id=""
                                placeholder=""
                                v-model="suggested.Dob"
                                @change="applyDateClickSuggested()"
                                style="width: 100%"
                              />
                            </span>
                          </div>
                        </div>
                      </div>
  
                      <div class="table-responsive">
                        <div
                          class="
                            dataTables_wrapper
                            container-fluid
                            dt-bootstrap4
                            no-footer
                          "
                        >
                          <div class="dataTables_length">
                            <span style="margin-right: 10px"
                              ><label for="">Show </label>
                            </span>
                            <select
                              v-model="pageSize"
                              class="form-control form-control-sm"
                              aria-label="Default select example"
                              @change="pageChangeSuggested(1)"
                            >
                              <option selected>50</option>
                              <option value="100">100</option>
                              <option value="500">500</option>
                              <!-- <option value="1000">1000</option>
                              <option value="2000">2000</option> -->
                            </select>
  
                            <span style="margin-left: 10px">
                              <label for=""> Entries </label></span
                            >
                          </div>
                        </div>
                        <table
                          class="
                            table
                            display
                            table-bordered
                            text-center
                            table-striped
                            no-wrap
                          "
                          id="home_2"
                        >
                          <thead class="thead-dark">
                            <tr>
                              <th style="text-align: start">
                                PT ID<span>
                                  <button
                                    class="asc-desc-btn"
                                    @click="orderBySuggested(1)"
                                  >
                                    &uarr; &darr;
                                  </button>
                                </span>
                              </th>
                              <th style="text-align: start">
                                External Id<span>
                                  <button
                                    class="asc-desc-btn"
                                    @click="orderBySuggested(2)"
                                  >
                                    &uarr; &darr;
                                  </button>
                                </span>
                              </th>
                              <th style="text-align: start">
                                First Name<span>
                                  <button
                                    class="asc-desc-btn"
                                    @click="orderBySuggested(3)"
                                  >
                                    &uarr; &darr;
                                  </button>
                                </span>
                              </th>
                              <th style="text-align: start">
                                Last Name<span>
                                  <button
                                    class="asc-desc-btn"
                                    @click="orderBySuggested(4)"
                                  >
                                    &uarr; &darr;
                                  </button>
                                </span>
                              </th>
                              <th style="text-align: start">
                                DOB<span>
                                  <button
                                    class="asc-desc-btn"
                                    @click="orderBySuggested(5)"
                                  >
                                    &uarr; &darr;
                                  </button>
                                </span>
                              </th>
                              <th style="text-align: start">
                                Email<span>
                                  <button
                                    class="asc-desc-btn"
                                    @click="orderBySuggested(6)"
                                  >
                                    &uarr; &darr;
                                  </button>
                                </span>
                              </th>
                              <th style="text-align: start">
                                Phone<span>
                                  <button
                                    class="asc-desc-btn"
                                    @click="orderBySuggested(7)"
                                  >
                                    &uarr; &darr;
                                  </button>
                                </span>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-if="suggestedPatients.length == 0">
                              <td align="center" colspan="100">
                                <strong> No data available</strong>
                              </td>
                            </tr>
                            <tr
                              v-for="(pat, ndx04) in suggestedPatients"
                              :key="ndx04"
                            >
                              <td>
                                <button
                                  class="
                                    btn btn-facebook btn-sm
                                    waves-effect waves-light
                                  "
                                  type="button"
                                  @click="checkPatient(pat)"
                                >
                                  {{ pat.ptid }}</button
                                >
                              </td>
                              <td>{{ pat.externalId }}</td>
                              <td>{{ pat.firstName }}</td>
                              <td>{{ pat.lastName }}</td>
                              <td>{{ pat.dob }}</td>
                              <td>
                                {{ pat.email }}
                              </td>
                              <td>{{ pat.phone }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <nav aria-label="Page navigation">
                        <span
                          style="padding-left: 40px"
                          v-if="
                            totalRowsSuggest < pageSizeSuggest * pageNumberSuggest
                          "
                          >showing {{ totalRowsSuggest }} of
                          {{ totalRowsSuggest }} records</span
                        >
                        <span style="padding-left: 40px" v-else
                          >showing {{ pageSizeSuggest * pageNumberSuggest }} of
                          {{ totalRowsSuggest }} records</span
                        >
                        <ul class="pagination" style="float: right">
                          <li class="page-item colorActive">
                            <span v-if="pageNumberSuggest == 1">
                              <button
                                disabled
                                class="page-link disabledColor"
                                @click="pageChangeSuggested('Previous')"
                              >
                                Previous
                              </button>
                            </span>
                            <span v-else>
                              <button
                                class="page-link"
                                @click="pageChangeSuggested('Previous')"
                              >
                                Previous
                              </button>
                            </span>
                          </li>
                          <!--show pagination-->
                          <li v-if="showPagesMin11 > 1">
                            <button
                              class="page-link"
                              @click="pageChangeSuggested(1)"
                            >
                              1
                            </button>
                          </li>
                          <li v-if="showPagesMin11 > 1">
                            <button disabled class="page-link disabledColor">
                              ...
                            </button>
                          </li>
                          <!--show pagination-->
                          <li
                            v-for="pageNumSugg in totalPagesSuggest"
                            :key="pageNumSugg"
                            class="page-item colorActive"
                          >
                            <span
                              v-if="
                                pageNumSugg >= showPagesMin11 &&
                                  pageNumSugg <= showPagesMax11
                              "
                            >
                              <span v-if="pageNumberSuggest == pageNumSugg"
                                ><button
                                  class="page-link activeColor"
                                  disabled
                                  @click="pageChangeSuggested(pageNumSugg)"
                                >
                                  {{ pageNumSugg }}
                                </button>
                              </span>
                              <span v-else>
                                <button
                                  class="page-link"
                                  @click="pageChangeSuggested(pageNumSugg)"
                                >
                                  {{ pageNumSugg }}
                                </button></span
                              >
                            </span>
                          </li>
                          <!--show pagination-->
                          <li
                            v-if="
                              totalPagesSuggest > 10 &&
                                totalPagesSuggest - 4 >= pageNumberSuggest
                            "
                          >
                            <button disabled class="page-link disabledColor">
                              ...
                            </button>
                          </li>
                          <li
                            v-if="
                              totalPagesSuggest > 10 &&
                                totalPagesSuggest - 4 >= pageNumberSuggest
                            "
                          >
                            <button
                              class="page-link"
                              @click="pageChangeSuggested(totalPagesSuggest)"
                            >
                              {{ totalPagesSuggest }}
                            </button>
                          </li>
                          <!--show pagination-->
                          <li class="page-item colorActive">
                            <span v-if="pageNumberSuggest == totalPagesSuggest">
                              <button
                                disabled
                                class="page-link disabledColor"
                                @click="pageChangeSuggested('Next')"
                              >
                                Next
                              </button>
                            </span>
                            <span v-else>
                              <button
                                class="page-link"
                                @click="pageChangeSuggested('Next')"
                              >
                                Next
                              </button>
                            </span>
                          </li>
                        </ul>
                      </nav>
                    </div>
                    <!-- <div v-else>
                        <hr class="solid text-black-50" />
                        <div class="row">
                          <div class="col-12">
                            <form class="floating-labels">
                              <legend
                                class="text-center"
                                style="font-weight: 900"
                              >
                                No suggestion(s) found...
                              </legend>
                            </form>
                          </div>
                      </div>
                    </div> -->
                    <!-- </div> -->
                  </div>
                </div>
                <!-- === Veins Patient === -->
              </div>
            </div>
          </div>
          <!-- Content -->
        </div>
      </div>
      <!-- Merge Modal -->

   
      <!-- Alert Modal -->
      <div
        class="modal bs-example-modal-lg fade"
        id="alertModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden="true"
        style="display: none; overflow-y: scroll"
      >
        <div class="modal-dialog col-12" style="max-width: none">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">Merge Patients</h4>
            </div>
  
            <div class="row">
              <div class="col-6">
                <button
                  type="button"
                  class="btn btn-outline-success waves-effect waves-light col-12"
                  style="margin-left: 5px"
                  id="model-merge0"
                  @click="mergeContinueClick"
                >
                  Continue
                </button>
              </div>
              <div class="col-6">
                <button
                  type="button"
                  class="btn btn-outline-danger waves-effect waves-light col-12"
                  style="margin-right: 25px !important;"
                  data-toggle="modal"
                  data-target="#alertModal"
                >
                  Close
                </button>
              </div>
            </div>
            <div class="modal-body">
              <form class="floating-labels m-t-40" style="margin-top: 10px;">
                <div class="row" style="width: 100%; height: 100%">
                  <div class="col-lg-3 col-sm-12 col-md-6">
                    <p
                      class="text-center font-weight-bold"
                      style="font-size: 20px"
                    >
                      &nbsp;&nbsp;
                    </p>
                    <div class="form-group m-b-40">
                      <div class="table-responsive">
                        <table
                          class="
                            table
                            display
                            table-bordered table-striped
                            no-wrap
                          "
                        >
                          <thead class="thead-dark">
                            <tr>
                              <th>PT ID</th>
                            </tr>
                          </thead>
                          <tbody style="font-weight: 900">
                            <tr>
                              <td>First Name</td>
                            </tr>
                            <tr>
                              <td>Last Name</td>
                            </tr>
                            <tr>
                              <td>DOB</td>
                            </tr>
                            <tr>
                              <td>Gender</td>
                            </tr>
                            <tr>
                              <td>Phone Number</td>
                            </tr>
                            <tr>
                              <td>Email</td>
                            </tr>
                            <tr>
                              <td>External ID</td>
                            </tr>
                            <tr>
                              <td>Social Security Number</td>
                            </tr>
                            <tr>
                              <td>Street</td>
                            </tr>
                            <tr>
                              <td>City</td>
                            </tr>
                            <tr>
                              <td>State</td>
                            </tr>
                            <tr>
                              <td>Zip</td>
                            </tr>
                            <tr>
                              <td>Primary Insurance</td>
                            </tr>
                            <tr>
                              <td>Primary Insurance Number</td>
                            </tr>
                            <tr>
                              <td>Primary Insurance Group ID</td>
                            </tr>
                            <!-- <tr class='image-row-heigth'>
                              <td>Primary Insurance ID</td>
                            </tr> -->
                            <tr>
                              <td>Secondary Insurance</td>
                            </tr>
                            <tr>
                              <td>Secondary Insurance Number</td>
                            </tr>
                            <tr>
                              <td>Secondary Insurance Group ID</td>
                            </tr>
                            <!-- <tr class='image-row-heigth'>
                              <td>Secondary Insurance ID</td>
                            </tr> -->
                            <tr>
                              <td>Visits</td>
                            </tr>
                            <tr>
                              <td>Payments</td>
                            </tr>
                            <tr>
                              <td>Emails</td>
                            </tr>
                            <tr>
                              <td>Texts</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
  
                  <div class="col-lg-3 col-sm-12 col-md-6">
                    <p
                      class="text-center font-weight-bold"
                      style="font-size: 20px"
                    >
                      Active Patient
                    </p>
                    <div class="form-group m-b-40">
                      <div class="table-responsive">
                        <table
                          class="
                            table
                            display
                            table-bordered table-striped
                            no-wrap
                          "
                        >
                          <thead class="thead-dark">
                            <tr>
                              <th>{{ aSinglePatient.ptid }}</th>
                            </tr>
                          </thead>
                          <tbody style="font-weight: 900">
                            <tr>
                              <td>{{ aSinglePatient.firstName }}</td>
                            </tr>
                            <tr>
                              <td>{{ aSinglePatient.lastName }}</td>
                            </tr>
                            <tr>
                              <td>{{ aSinglePatient.dob }}</td>
                            </tr>
                            <tr>
                              <td>{{ aSinglePatient.gender }}</td>
                            </tr>
                            <tr>
                              <td>{{ aSinglePatient.phone }}</td>
                            </tr>
                            <tr>
                              <td>
                                {{ aSinglePatient.email }}
                                <!-- <span
                                class="__cf_email__"
                                data-cfemail="f68597988597849fc4b6919b979f9ad895999b"
                                >[email&#160;protected]</span
                              > -->
                              </td>
                            </tr>
                            <tr>
                              <td>{{ aSinglePatient.externalId }}</td>
                            </tr>
                            <tr>
                              <td>{{ aSinglePatient.ssn }}</td>
                            </tr>
                            <tr>
                              <td>{{ aSinglePatient.address }}</td>
                            </tr>
                            <tr>
                              <td>{{ aSinglePatient.city }}</td>
                            </tr>
                            <tr>
                              <td>{{ aSinglePatient.state }}</td>
                            </tr>
                            <tr>
                              <td>{{ aSinglePatient.zip }}</td>
                            </tr>
                            <tr>
                              <td>
                                {{ aSinglePatient.insurance.primaryInsurance }}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                {{ aSinglePatient.insurance.primaryInsuranceNo }}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                {{
                                  aSinglePatient.insurance.primaryInsuranceGroupId
                                }}
                              </td>
                            </tr>
                            <!-- <tr class="image-row-heigth">
                              <td >
                                <img v-if="aSinglePatient.insurance.primaryInsuranceId==''"
                                class="insurance-images" 
                                src="assets/images/No_image_insurance.jpg"
                                />
                                <img v-else
                                 class="insurance-images" 
                                :src='aSinglePatient.insurance.primaryInsuranceId'
                                />                         
                              </td>
                            </tr> -->
                            <tr>
                              <td>
                                {{ aSinglePatient.insurance.secondaryInsurance }}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                {{
                                  aSinglePatient.insurance.secondaryInsuranceNo
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                {{
                                  aSinglePatient.insurance
                                    .secondaryInsuranceGroupId
                                }}
                              </td>
                            </tr>
                            <!-- <tr class="image-row-heigth">
                              <td>
                                {{
                                  aSinglePatient.insurance.secondaryInsuranceId
                                }}
                              </td>
                            </tr> -->
                            <tr>
                              <td v-if="aSinglePatient.patientId != 0">
                                {{ aSinglePatient.stats.visits }}
                              </td>
                              <td v-else>
                                {{ (aSinglePatient.stats.visits = 1) }}
                              </td>
                            </tr>
                            <tr>
                              <td v-if="aSinglePatient.patientId != 0">
                                {{ aSinglePatient.stats.payments }}
                              </td>
                              <td v-else>
                                {{ (aSinglePatient.stats.payments = 0) }}
                              </td>
                            </tr>
                            <tr>
                              <td v-if="aSinglePatient.patientId != 0">
                                {{ aSinglePatient.stats.emails }}
                              </td>
                              <td v-else>
                                {{ (aSinglePatient.stats.emails = 0) }}
                              </td>
                            </tr>
                            <tr>
                              <td v-if="aSinglePatient.patientId != 0">
                                {{ aSinglePatient.stats.texts }}
                              </td>
                              <td v-else>
                                {{ (aSinglePatient.stats.texts = 0) }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
  
                  <div class="col-lg-3 col-sm-12 col-md-6">
                    <p
                      class="text-center font-weight-bold"
                      style="font-size: 20px"
                    >
                      Selected Patient
                      {{ aSelectedPatient.ptid }}
                    </p>
                    <div class="form-group m-b-40">
                      <div class="table-responsive">
                        <table
                          class="
                            table
                            display
                            table-bordered table-striped
                            no-wrap
                          "
                        >
                          <thead class="thead-dark">
                            <tr>
                              <th>
                                {{ aSelectedPatient.ptid }}
                              </th>
                            </tr>
                          </thead>
                          <tbody style="font-weight: 900">
                            <tr>
                              <td>
                                {{ aSelectedPatient.firstName }}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                {{ aSelectedPatient.lastName }}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                {{ aSelectedPatient.dob }}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                {{ aSelectedPatient.gender }}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                {{ aSelectedPatient.phone }}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                {{ aSelectedPatient.email }}
                                <!-- <span
                                class="__cf_email__"
                                data-cfemail="f68597988597849fc4b6919b979f9ad895999b"
                                >[email&#160;protected]</span
                              > -->
                              </td>
                            </tr>
                            <tr>
                              <td>
                                {{ aSelectedPatient.externalId }}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                {{ aSelectedPatient.ssn }}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                {{ aSelectedPatient.streetAddress }}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                {{ aSelectedPatient.city }}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                {{ aSelectedPatient.state }}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                {{ aSelectedPatient.zip }}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                {{ aSelectedInsurance.primaryInsurance }}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                {{ aSelectedInsurance.primaryInsuranceNo }}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                {{ aSelectedInsurance.primaryInsuranceGroupId }}
                              </td>
                            </tr>
                            <!-- <tr  class="image-row-heigth">
                              <td>                                   
                                <img v-if="aSelectedInsurance.primaryInsuranceId==''"
                                class="insurance-images" 
                                
                                src="assets/images/No_image_insurance.jpg"
                                />
                                <img v-else
                                 class="insurance-images" 
                                :src='aSelectedInsurance.primaryInsuranceId'
                                />
                              </td>
                            </tr> -->
                            <tr>
                              <td>
                                {{ aSelectedInsurance.secondaryInsurance }}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                {{ aSelectedInsurance.secondaryInsuranceNo }}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                {{ aSelectedInsurance.secondaryInsuranceGroupId }}
                              </td>
                            </tr>
                            <!-- <tr  class="image-row-heigth">
                              <td>
                                {{ aSelectedInsurance.secondaryInsuranceId }}
                              </td>
                            </tr> -->
                            <tr>
                              <td>{{ aSelectedPatient.totalVisits }}</td>
                            </tr>
                            <tr>
                              <td>{{ aSelectedPatient.paymentReceived }}</td>
                            </tr>
                            <tr>
                              <td>{{ aSelectedPatient.totalEmails }}</td>
                            </tr>
                            <tr>
                              <td>{{ aSelectedPatient.totalText }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
  
                  <div class="col-lg-3 col-sm-12 col-md-6">
                    <p
                      class="text-center font-weight-bold"
                      style="font-size: 20px"
                    >
                      Merged Patient
                    </p>
                    <div class="form-group m-b-40">
                      <div class="table-responsive">
                        <table
                          id="mainTable999"
                          class="
                            table
                            editable-table
                            table-bordered table-striped
                            m-b-0
                          "
                          style="cursor: pointer"
                        >
                          <thead class="thead-dark">
                            <tr>
                              <th>{{ aSelectedPatient.ptid }}</th>
                            </tr>
                          </thead>
                          <tbody style="font-weight: 900">
                            <tr>
                              <!-- **777** -->
  
                              <!-- <td>{{ aSinglePatient.firstName }}</td> -->
                              <td>
                                <input
                                  :style="mergePatientInputStyle()"
                                  type="text"
                                  v-model="mergedPat.firstName"
                                />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <input
                                  :style="mergePatientInputStyle()"
                                  type="text"
                                  v-model="mergedPat.lastName"
                                />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <input
                                  :style="mergePatientInputStyle()"
                                  type="date"
                                  v-model="mergedPat.dob"
                                />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <select
                                  :style="mergePatientInputStyle()"
                                  tabindex="1"
                                  v-model="mergedPat.gender"
                                >
                                  <option value="0">Choose a Gender</option>
                                  <option value="Male">Male</option>
                                  <option value="Female">Female</option>
                                  <option value="Others">Others</option>
                                </select>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <input
                                  v-mask="'###-###-####'"
                                  type="tel"
                                  id="phonenumber"
                                  :style="mergePatientInputStyle()"
                                  v-model="mergedPat.phone"
                                />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <input
                                  type="text"
                                  id=""
                                  :style="mergePatientInputStyle()"
                                  v-model="mergedPat.email"
                                />
                                <!-- <span
                                class="__cf_email__"
                                data-cfemail="f68597988597849fc4b6919b979f9ad895999b"
                                >[email&#160;protected]</span
                              > -->
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <input
                                  type="text"
                                  id=""
                                  :style="mergePatientInputStyle()"
                                  v-model="mergedPat.externalId"
                                />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <input
                                  v-mask="'###-###-###'"
                                  type="tel"
                                  :style="mergePatientInputStyle()"
                                  v-model="mergedPat.ssn"
                                />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <input
                                  :style="mergePatientInputStyle()"
                                  type="text"
                                  v-model="mergedPat.address"
                                />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <input
                                  :style="mergePatientInputStyle()"
                                  type="text"
                                  v-model="mergedPat.city"
                                />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <input
                                  :style="mergePatientInputStyle()"
                                  type="text"
                                  v-model="mergedPat.state"
                                />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <input
                                  v-mask="'######'"
                                  type="tel"
                                  :style="mergePatientInputStyle()"
                                  v-model="mergedPat.zip"
                                />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <input
                                  :style="mergePatientInputStyle()"
                                  type="text"
                                  v-model="mergedPat.primaryIns"
                                />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <input
                                  :style="mergePatientInputStyle()"
                                  type="text"
                                  v-model="mergedPat.primaryInsNo"
                                />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <input
                                  :style="mergePatientInputStyle()"
                                  type="text"
                                  v-model="mergedPat.primaryInsGroupId"
                                />
                              </td>
                            </tr>
                            <!-- <tr  class="image-row-heigth">
                              <td>
                                <input
                                  disabled
                                  :style="mergePatientInputStyle()"
                                  type="text"
                                  v-model="mergedPat.primaryInsId"
                                />
                              </td>
                            </tr> -->
                            <tr>
                              <td>
                                <input
                                  :style="mergePatientInputStyle()"
                                  type="text"
                                  v-model="mergedPat.secondIns"
                                />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <input
                                  :style="mergePatientInputStyle()"
                                  type="text"
                                  v-model="mergedPat.secondInsNo"
                                />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <input
                                  :style="mergePatientInputStyle()"
                                  type="text"
                                  v-model="mergedPat.secondInsGroupId"
                                />
                              </td>
                            </tr>
                            <!-- <tr class="image-row-heigth">
                              <td>
                                <input
                                  disabled
                                  :style="mergePatientInputStyle()"
                                  type="text"
                                  v-model="mergedPat.secondInsId"
                                />
                              </td>
                            </tr> -->
                            <!-- <tr>
                            <td>
                              {{
                                aSinglePatient.insurance.secondaryInsuranceId
                              }}
                            </td>
                          </tr> -->
                            <tr>
                              <td>
                                {{
                                  aSinglePatient.stats.visits +
                                    aSelectedPatient.totalVisits
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                {{
                                  aSinglePatient.stats.payments +
                                    aSelectedPatient.paymentReceived
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                {{
                                  aSinglePatient.stats.emails +
                                    aSelectedPatient.totalEmails
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                {{
                                  aSinglePatient.stats.texts +
                                    aSelectedPatient.totalText
                                }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <!-- Alert Modal -->
  
  </div>
</template>
<script src='./jsfiles/Checkout.js'></script>

<style scoped>
  .float-textarea,
  .float-class:hover {
    border-top-style: hidden;
    border-right-style: hidden;
    border-left-style: hidden;
    background: transparent;
    border-bottom: 1px solid rgb(235, 235, 235);
    /* box-shadow: none; */
    width: 98%;
  }

  .float-textarea:focus {
    border-top-style: hidden;
    border-right-style: hidden;
    border-left-style: hidden;
    background: transparent;
    border-bottom: 2px solid rgb(240, 141, 11);
    /* box-shadow: none; */
    width: 98%;
  }

  .float-class,
  .float-class:hover {
    border-top-style: hidden;
    border-right-style: hidden;
    border-left-style: hidden;
    background: transparent;
    /* border-bottom: 2px solid rgb(240, 141, 11); */
    border-bottom: 1px solid rgb(235, 235, 235);
    box-shadow: none;
  }

  .float-class:focus {
    border-top-style: hidden;
    border-right-style: hidden;
    border-left-style: hidden;
    background: transparent;
    border-bottom: 2px solid rgb(240, 141, 11);
    box-shadow: none;
  }

  #font1 {
    font-weight: bold;
    font-size: 15px;
    margin-left: -7px;
  }

  .label_select {
    margin-top: -23px;
    margin-left: 0px;
  }

  .activeColor {
    background-color: #fb9678;
    color: white;
  }

  .colorActive {
    color: #f95c2e
  }

  .disabledColor {
    color: gray;
    background: lightgrey;
  }

  .asc-desc-btn {
    background-color: transparent;
    background-repeat: no-repeat;
    border: none;
    cursor: pointer;
    overflow: hidden;
    outline: none;
    color: honeydew;
    float: right;
  }

  .switch {
    position: relative;
    display: inline-block;
    width: 60px;
    height: 34px;
  }

  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 26px;
    width: 26px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  input:checked+.slider {
    background-color: #00c292;
  }

  input:focus+.slider {
    box-shadow: 0 0 1px #00c292;
  }

  input:checked+.slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
  }

  .slider.round {
    height: 34px;
    width: 56px;
    border-radius: 24px;
  }

  .slider.round:before {
    border-radius: 50%;
  }

  .label-color {
    color: black;
  }
  
</style>

